import { Vue, Component, Watch } from 'vue-property-decorator';
import { Mutation } from 'vuex-class';

import TkSelect from '@/../bower_components/teknisavuecomponents/components/fields/TkSelect.vue';
import TkDate from '@/../bower_components/teknisavuecomponents/components/fields/TkDate.vue';
import TkForm from '@/../bower_components/teknisavuecomponents/components/TkForm.vue';
import TkToolbar from '@/../bower_components/teknisavuecomponents/components/grids/TkToolbar.vue';

import SnackbarUtils from '@/../bower_components/teknisavuecomponents/assets/utils/SnackbarUtils';
import HttpRequest from '@/../bower_components/teknisavuecomponents/assets/utils/HttpRequest';
import DateUtil from '@/../bower_components/teknisavuecomponents/assets/utils/DateUtil';
import Util from '@/../bower_components/teknisavuecomponents/assets/utils/Util';
import FileUtils from '@/../bower_components/teknisavuecomponents/assets/utils/FileUtils';
import ToolbarAction from '@/../bower_components/teknisavuecomponents/assets/interfaces/ToolbarAction';
import Field from '@/../bower_components/teknisavuecomponents/assets/interfaces/Field';
import User from '@/assets/ts/interfaces/User';
import Periodo from '@/../bower_components/teknisavuecomponents/assets/interfaces/Periodo';
import NovaSolicitacaoController from '@/assets/ts/controller/NovaSolicitacaoController';
import { SolicitacaoController, TiposSolicitacao } from '@/assets/ts/controller/SolicitacaoController';
import RelatorioController from '@/assets/ts/controller/RelatorioController';
import AdmissaoController from '@/assets/ts/controller/AdmissaoController';
import TreinamentoController from '@/assets/ts/controller/TreinamentoController';
import { OcorrenciaController } from '@/assets/ts/controller/OcorrenciaController';
import CommonRequests from '@/assets/ts/controller/CommonRequests';

import NovaAssinaturaRelatorio from '@/components/relatorio/NovaAssinaturaRelatorio/NovaAssinaturaRelatorio.vue';
import CordovaController from '@/assets/ts/controller/CordovaController';
import OfflineController from '@/assets/ts/controller/OfflineController';
import { isBefore, parse } from 'date-fns';
import RelatorioResumoMovimentoHierarquia from './reports/resumo_movimento_hierarquia';
import ReportFields from './ReportFields';
import { IReportType, ReportType } from './report-interfaces';

const REPORT_TYPE_PDF = 'PDF';
const REPORT_TYPE_XLS = 'XLS';
interface Estrutura {
  NMESTRUTURA: string;
  NRESTRUTURAM: string;
  IDTIPOESTRUTURA: string;
  NRTIPOESTRUTURA: string;
}

@Component({
  name: 'Relatorio',
  components: {
    TkSelect,
    TkDate,
    TkForm,
    TkToolbar,
    NovaAssinaturaRelatorio,
  },
})
class Relatorio extends Vue {
  // #region [ STORE ]
  private get user(): User {;
    return this.$store.getters.user;
  }

  private get periodoDemonstrativoAtual(): Periodo {
    return this.$store.getters.periodoDemonstrativoAtual;
  }

  private get estruturaGerencialAtual(): Estrutura {
    return this.$store.getters.estruturaGerencialAtual;
  }

  private get estruturasGerenciaisStore(): Estrutura[] {
    return this.$store.getters.estruturasGerenciais;
  }

  private get periodosDemonstrativo(): Periodo[] {
    return this.$store.getters.periodosDemonstrativo;
  }

  private get isReportSolicitacao(): boolean {
    const valueReport = this.selectedReport && this.selectedReport.value as TiposSolicitacao;
    return Object.values(TiposSolicitacao).includes(valueReport)
  }

  private isEstruturaSupSelected(): boolean {
    return Util.isEmptyOrBlank(this.formRow.NRESTRUTSUPERIOR);
  }

  private isDtFimSolicitacaoSelected(): boolean {
    return !Util.isEmptyOrBlank(this.formRow.DTFIMSOLICITACAO);
  }

  private get toolbarActions(): ToolbarAction[] {
    return [
      {
        name: 'generate',
        label: 'Gerar Relatório',
        icon: 'mdi-file-chart',
        showLabel: false,
        onClick: this.showReportOnScreen,
        condition: this.isReportAllowedToBeGenerated,
      },
      {
        name: 'download',
        label: 'Baixar Relatório',
        icon: 'mdi-download',
        showLabel: false,
        onClick: this.downloadReport,
        condition: !this.isReportSolicitacao
      },
      {
        name: 'exportDataOptions',
        label: 'Baixar Relatório',
        icon: 'mdi-file-export-outline',
        menu: true,
        items: [
          {
            name: 'exportToPdf',
            label: 'Exportar para PDF',
            onClick: () => this.generateSolicitacaoEspelhoReport(REPORT_TYPE_PDF),
          },
          {
            name: "exportToXls",
            label: "Exportar para XLS",
            onClick: () => this.generateSolicitacaoEspelhoReport(REPORT_TYPE_XLS),
          },
        ],
        condition: this.isReportSolicitacao
      },
      {
        name: 'signature',
        label: 'Enviar para Assinar',
        icon: 'mdi-draw',
        showLabel: false,
        onClick: this.sendToSign,
        condition: this.isReportAllowedToBeSend,
      },
    ];
  }

  private get isReportAllowedToBeGenerated(): boolean {
    return this.selectedReport && !this.selectedReport.hideGenerateAction;
  }

  private get isReportAllowedToBeSend(): boolean {
    // Não exibir o botão "Enviar para Assinar" quando a opção "Com Assinatura Digital" estiver marcada como "Sim"
    return this.user.dp && this.selectedReport && !this.selectedReport.hideSendAction && this.formRow.COMASSINATURADIGITAL !== 'S';
    // return this.user.dp && this.selectedReport && !this.selectedReport.hideSendAction;
  }

  @Mutation('changeCurrentView')
  private changeCurrentView: (view: string) => void;
  // #endregion

  // #region [ DATA ]
  private viewName = 'Relatório';
  private loading = false;
  public contentHeight: number = null;

  private injectedReports: IReportType[] = [
    new RelatorioResumoMovimentoHierarquia(this),
  ];

  private reportFields = new ReportFields(this);

  get fields() {
    return this.reportFields.fields;
  }

  private reportLink = '';
  private showReport = false;

  private base64 = '';
  private type = '';

  private assinaturaPopup = {
    show: false,
    row: null,
  };

  private prevNrEstrutura = '';
  private vinculos = [];

  estruturaGerencialObrigatorio = false;

  public fieldsData = {
    estruturasGerenciais: [] as any[],
    estruturasLegais: [] as any[],
    vinculos: [] as any[],
    periodos: this.periodosDemonstrativo,
    tiposHierarquia: [] as any[],
    estruturasSuperiores: [] as any[],
    estruturasSuperioresOperador: [] as any[],
    bancos: [] as any[],
    eventos: [] as any[],
    tiposVinculo: [] as any[],
    loteVinculos: [] as any[],
    ocupacoes: [] as any[],
    motivosOcupa: [] as any[],
    templates: [] as any[],
    tiposProcesso: [] as any[],
    escalas: [] as any[],
    turnos: [] as any[],
    tiposAviso: [] as any[],
    tiposDemissao: [] as any[],
    motivosRescisao: [] as any[],
    vinculosEmpregaticios: [] as any[],
    pessoas: [] as any[],
    beneficios: [] as any[],
    tiposRelacionamento: [] as any[],
    transferencias: [] as any[],
    motivosTransferencia: [] as any[],
    tiposAlteraSal: [] as any[],
    cursos: [] as any[],
    perfisAcesso: [] as any[],
    metodos: [] as any[],
    beneficiosCombustivel: [] as any[],
    beneficiosManutencao: [] as any[],
    linhas: [] as any[],
    tiposLinha: [] as any[],
    tiposBeneficio: [] as any[],
    solicitacoes: [] as any[],
    tiposIncidencia: [] as any[],
  };

  private defaultFilters = {
    NRVINCULOM: null as number,
    NRORG: null as string,
    NRPERIODOAPURACAO: null as string,
    CDOPERADOR: this.user.cdoperador,
  };

  private defaultRow = {
    reportName: 'folha_ponto',
    DTMESCOMPETENCIA: DateUtil.getDateCompetenc(),
    NRPERIODOAPURACAO: null as string,
    NRESTRUTLEGAL: this.user.nrestrutlegal,
    NRTIPOHIERARQ: null as string,
  };

  private formRow: any = {};

  private get injectedReportsObjects() {
    return this.injectedReports.map((instance) => ({
      name: instance.name,
      value: instance.value,
      fields: instance.fields,
      onSelection: instance.onSelection,
      beforeGeneration: instance.beforeGeneration,
      params: instance.params,
      defaultRow: instance.defaultRow,
      restricted: instance.restricted,
      sendEmptyParams: instance.sendEmptyParams,
      fieldsDP: instance.fieldsDP,
      hideGenerateAction: instance.hideGenerateAction,
      hideSendAction: instance.hideSendAction,
    }));
  }

  public dtCompetenciaField: Field = {
    name: 'DTMESCOMPETENCIA',
    label: 'Data de Competência',
    type: 'date',
    month: true,
    size: 4,
    required: true,
    onInput: this.dtCompetenciaOnInput,
  };

  private dtDataField: Field = {
    name: 'DATA',
    label: 'Data',
    type: 'date',
    size: 4,
    required: true,
  };

  private periodoApuracao: Field = {
    name: 'NRPERIODOAPURACAO',
    valueField: 'NRPERIODOAPURACAO',
    descriptionField: 'DSPERIODOAPURACAO',
    label: 'Período de Apuração',
    type: 'select',
    size: 4,
    required: true,
    items: this.fieldsData.periodos,
  };

  private anoReferenciaField: Field = {
    name: 'NRANOREF',
    label: 'Ano de Referência',
    type: 'number',
    size: 3,
    required: true,
  };

  private anoCalendarioField: Field = {
    name: 'NRANOCAL',
    label: 'Ano de Calendário',
    type: 'number',
    size: 3,
    required: true,
  };

  public tipoMovimentoField: Field = {
    name: 'NRTIPOMOVIMENT',
    valueField: 'value',
    descriptionField: 'name',
    label: 'Tipo de Movimento',
    type: 'autocomplete',
    size: 6,
    items: [
      {
        name: 'Mensal',
        value: '1',
      },
      {
        name: 'Férias',
        value: '2',
      },
      {
        name: '13º Salário',
        value: '4',
      },
      {
        name: 'Rescisão',
        value: '9',
      },
      {
        name: 'Adiantamento',
        value: '10',
      },
      {
        name: 'Vale Transporte',
        value: '17',
      },
      {
        name: 'Participação nos Lucros',
        value: '19',
      },
    ],
  };

  public ignorarOcorrField: Field = {
    name: 'IGNORAOCORR',
    valueField: 'value',
    descriptionField: 'name',
    label: 'Ignorar Ocorrências de Cálculo',
    type: 'select',
    size: 6,
    items: [
      {
        name: 'Sim',
        value: 'S',
      },
      {
        name: 'Não',
        value: 'N',
      },
    ],
  };

  private duasViasField: Field = {
    name: 'DUASVIAS',
    valueField: 'value',
    descriptionField: 'name',
    label: '2 Vias',
    type: 'select',
    size: 6,
    items: [
      {
        name: 'Sim',
        value: 'S',
      },
      {
        name: 'Não',
        value: 'N',
      },
    ],
  };

  private observacaoField: Field = {
    name: 'DSOBSERVACAO',
    label: 'Observação',
    type: 'textarea',
    size: 12,
    rows: 2,
  };

  private dtInicioField: Field = {
    name: 'DTINICIO',
    label: 'Data Inicial da Admissão',
    type: 'date',
    month: false,
    size: 4,
  };

  private dtFimField: Field = {
    name: 'DTFIM',
    label: 'Data Final da Admissão',
    type: 'date',
    month: false,
    size: 4,
  };

  private dtDocumentoField: Field = {
    name: 'DTDOCUMENTO',
    label: 'Data do Documento',
    type: 'date',
    month: false,
    size: 4,
  };

  private dtCompetenciaFimField: Field = {
    name: 'DTMESCOMPETENCIAFIM',
    label: 'Data de Competência Final',
    type: 'date',
    month: true,
    size: 4,
  };

  private dtSolicitacaoField: Field = {
    name: 'DTSOLICITACAO',
    label: 'Data de Solicitação',
    type: 'date',
    size: 4,
    required: false,
  };

  private statusField: Field = {
    name: 'DSAPROVACAOSEC',
    label: 'Status',
    type: 'select',
    valueField: 'value',
    descriptionField: 'name',
    items: [
      {
        name: 'Pendente',
        value: 'P',
      },
      {
        name: 'Aprovada',
        value: 'A',
      },
      {
        name: 'Reprovada',
        value: 'R',
      },
      {
        name: 'Em andamento',
        value: 'E',
      },
    ],
    size: 6,
    required: false,
  };

  private get dtInicioSolicitacaoField(): Field {
    const field: Field = {
      name: 'DTINICIOSOLICITACAO',
      label: 'Dt. Inicio',
      type: 'date',
      size: 6,
      required: this.isDtFimSolicitacaoSelected(),
    };

    return field;
  }

  private dtFimSolicitacaoField: Field = {
    name: 'DTFIMSOLICITACAO',
    label: 'Dt. Fim',
    type: 'date',
    size: 6,
    required: false,
  };

  private dtGozoIniField: Field = {
    name: 'DTINIGOZO',
    label: 'Data Inicial de Gozo de Férias',
    type: 'date',
    size: 6,
  };

  private dtGozoFimField: Field = {
    name: 'DTFIMGOZO',
    label: 'Data Final de Gozo de Férias',
    type: 'date',
    size: 6,
  };

  private dtHorasExtrasField: Field = {
    name: 'DTAPROVAHE',
    label: 'Data da Realização',
    type: 'date',
    size: 4,
    required: false,
  };

  private horaInicioHorasExtrasField: Field = {
    name: 'QTINIHOR',
    label: 'Hora Início',
    type: 'text',
    mask: '##:##',
    size: 4,
    required: false,
  };

  private horaFimHorasExtrasField: Field = {
    name: 'QTFIMHOR',
    label: 'Hora Fim',
    type: 'text',
    mask: '##:##',
    size: 4,
    required: false,
  };

  private dtInicioEscalaField: Field = {
    name: 'DTINIESCALA',
    label: 'Início da Escala',
    type: 'date',
    size: 4,
    required: false,
  };

  private get escalaField(): Field {
    const field = {
      name: 'NRESCALATRABM',
      label: 'Escala de Trabalho',
      type: 'autocomplete',
      descriptionField: 'NRNMESCALATRABM',
      valueField: 'NRESCALATRABM',
      size: 4,
      required: false,
      items: this.fieldsData.escalas,
      onInput: this.loadTurno,
    };

    return field;
  }

  private get turnoField(): Field {
    const field = {
      name: 'NRTURNO',
      label: 'Turno',
      type: 'autocomplete',
      descriptionField: 'NRDSTURNO',
      valueField: 'NRTURNO',
      items: this.fieldsData.turnos,
      size: 4,
      required: false,
    };

    return field;
  }
  
  private get salarioField(): Field {
    const field = {
      name: 'VRSALARIO',
      label: 'Salário',
      type: 'number',
      size: 4,
      required: false,
      onInput: this.fixField,
    };

    return field;
  }


  private tipoSalarioField: Field = {
    name: 'IDTPSALARIO',
    label: 'Tipo de Salário',
    type: 'select',
    valueField: 'value',
    descriptionField: 'name',
    size: 4,
    items: [
      {
        name: 'MENSAL',
        value: 'Mensal',
      },
      {
        name: 'QUINZENAL',
        value: 'Quinzenal',
      },
      {
        name: 'SEMANAL',
        value: 'Semanal',
      },
      {
        name: 'DIARIO',
        value: 'Diário',
      },
      {
        name: 'HORA',
        value: 'Hora',
      },
      {
        name: 'TAREFA',
        value: 'Tarefa',
      },
    ],
    required: false,
  };

  private dtAlteracaoSalField: Field = {
    name: 'DTALTESALARIO',
    label: 'Data da Alteração',
    type: 'date',
    size: 4,
    required: false,
  };

  private get ocupacaoField(): Field {
    const field = {
      name: 'NROCUPACAOM',
      label: 'Ocupação',
      size: 4,
      type: 'autocomplete',
      valueField: 'NROCUPACAOM',
      descriptionField: 'NRNMOCUPACAO',
      items: this.fieldsData.ocupacoes,
      required: false,
    };

    return field;
  }

  private get motivoAlteOcupaField(): Field {
    const field = {
      name: 'NRMOTIVOOCUPA',
      label: 'Motivo',
      size: 4,
      type: 'autocomplete',
      valueField: 'NRMOTIVOOCUPA',
      descriptionField: 'NMMOTIVOOCUPA',
      items: this.fieldsData.motivosOcupa,
      required: false,
    };

    return field;
  }

  private tipoOcupacaoField: Field = {
    name: 'NRTIPOOCUPACAO',
    label: 'Tipo',
    valueField: 'value',
    descriptionField: 'name',
    type: 'select',
    size: 4,
    required: false,
    items: [
      {
        value: '1',
        name: 'Cargo Efetivo',
      },
      {
        value: '2',
        name: 'Função',
      },
      {
        value: '3',
        name: 'Especialidade',
      },
      {
        value: '4',
        name: 'Cargo Comissionado',
      },
      {
        value: '5',
        name: 'Cargo Amparado/Apostilado',
      },
      {
        value: '6',
        name: 'Cargo Eletivo',
      },
      {
        value: '7',
        name: 'Recrutamento e Seleção', 
      },
    ],
  };

  private dtIniOcupaField: Field = {
    label: 'Início Ocupação',
    name: 'DTINIOCUPACAO',
    type: 'date',
    size: 4,
    required: false,
    month: true,
  };

  private nmProcessoField: Field = {
    name: 'NMPROCESSO',
    label: 'Nome do Processo',
    type: 'text',
    size: 4,
    required: false,
  };

  private get templateProcessoField(): Field {
    const field = {
      name: 'NRTEMPLATE',
      label: 'Template',
      type: 'autocomplete',
      size: 4,
      descriptionField: 'NMTEMPLATE',
      valueField: 'NRTEMPLATE',
      items: this.fieldsData.templates,
    };

    return field;
  }

  private get tipoProcessoField(): Field {
    const field = {
      name: 'NRTIPOPROCESSO',
      label: 'Tipo de Processo',
      type: 'autocomplete',
      size: 4,
      descriptionField: 'NMTIPOPROCESSO',
      valueField: 'NRTIPOPROCESSO',
      items: this.fieldsData.tiposProcesso,
    };

    return field;
  }

  private dataInicioProcessoField: Field = {
    name: 'DTSOLICITA',
    label: 'Disponível desde',
    type: 'date',
    size: 4,
  };

  private dataFimProcessoField: Field = {
    name: 'DTLIMSOLICITA',
    label: 'Disponível até',
    type: 'date',
    size: 4,
  };

  private dataPrevistaField: Field = {
    name: 'DTPREVISTAADMISSAO',
    label: 'Data previsata de admissão',
    type: 'date',
    size: 4,
  };

  private qntVagasProcessoField: Field = {
    name: 'NRVAGAS',
    label: 'Número de Vagas',
    type: 'number',
    size: 4,
  };

  private get tipoAvisoPrevioField(): Field {
    const field: Field = {
      name: 'NRTPAVIPRE',
      label: 'Tipo de Aviso Prévio',
      valueField: 'NRTPAVIPRE',
      descriptionField: 'DSTPAVIPRE',
      type: 'autocomplete',
      size: 4,
      required: false,
      items: this.fieldsData.tiposAviso,
    };

    return field;
  }
  
  private get tipoDemissaoField(): Field {
    const field: Field = {
      name: 'NRTPDEMISSAO',
      label: 'Tipo de Demissão',
      valueField: 'NRTPDEMISSAO',
      descriptionField: 'NMABREV',
      type: 'autocomplete',
      size: 4,
      required: false,
      items: this.fieldsData.tiposDemissao,
    };

    return field;
  }

  private get motivoRescisaoField(): Field {
    const field: Field = {
      name: 'NRMOTIVORESC',
      label: 'Motivo da Rescisão',
      valueField: 'NRMOTIVORESC',
      descriptionField: 'NMMOTIVORESC',
      type: 'autocomplete',
      size: 4,
      required: false,
      items: this.fieldsData.motivosRescisao,
    };

    return field;
  }

  private get dataUltDiaTrabField(): Field {
    const field: Field = {
      name: 'DTRESCISAOVINC',
      label: 'Dt. de Rescisão Vínculo',
      type: 'date',
      size: 4,
    };

    return field;
  }

  private get dataResciProjField(): Field {
    const field: Field = {
      name: 'DTRESCISAOPROJETADA',
      label: 'Dt. Rescisão Projetada',
      type: 'date',
      size: 4,
    };

    return field;
  }

  private get possuiBensField(): Field {
    const field: Field = {
      name: 'CDPOSSUIBENSDAEMPRESA',
      label: 'Possui bens da Empresa (Celular, Notebook e etc)',
      type: 'select',
      valueField: 'value',
      descriptionField: 'name',
      size: 4,
      items: [
        {
          name: 'Sim',
          value: 'S',
        },
        {
          name: 'Não',
          value: 'N',
        },
      ],
    };

    return field;
  }

  private get reposicaoVagaField(): Field {
    const field: Field = {
      name: 'CDREPOSICAOVAGA',
      label: 'Reposição de Vaga',
      type: 'select',
      valueField: 'value',
      descriptionField: 'name',
      size: 4,
      items: [
        {
          name: 'Sim',
          value: 'S',
        },
        {
          name: 'Não',
          value: 'N',
        },
      ],
    };

    return field;
  }

  private get pessoaNaoGrataField(): Field {
    const field: Field = {
      name: 'CDPESSOANAOGRATA',
      label: 'Pessoa não Grata',
      type: 'select',
      valueField: 'value',
      descriptionField: 'name',
      size: 4,
      items: [
        {
          name: 'Sim',
          value: 'S',
        },
        {
          name: 'Não',
          value: 'N',
        },
      ],
    };

    return field;
  }

  private get vinculoEmpregaticioField(): Field {
    const field: Field = {
      name: 'NRVINCULOEMPREG',
      label: 'Vínculo Empregatício',
      type: 'autocomplete',
      descriptionField: 'NMABREV',
      valueField: 'NRVINCULOEMPREG',
      size: 4,
      items: this.fieldsData.vinculosEmpregaticios,
    };

    return field;
  }
  
  private situFuncSuspensaoField: Field = {
    name: 'NRSITUFUNCM',
    label: 'Situacação Funcional',
    size: 6,
    type: 'autocomplete',
    valueField: 'NRSITUFUNCM',
    descriptionField: 'NMSITUFUNCH',
    items: [
      {
        NMSITUFUNCH: 'Advertência',
        NRSITUFUNCM: '18',
      },
      {
        NMSITUFUNCH: 'Suspensão',
        NRSITUFUNCM: '100051',
      },
    ],
    required: false,
  };

  private dtIniSuspensaoField: Field = {
    name: 'DTINISITUFUNC',
    label: 'Data Início',
    type: 'date',
    size: 4,
    required: false,
  };

  private qtdeDiasSuspensaoField: Field = {
    name: 'NRQTDIASITUFUNC',
    label: 'Qtde de Dias',
    type: 'number',
    size: 4,
    required: false,
  };
  
  private dtFimSuspensaoField: Field = {
    name: 'DTFIMSITUFUNC',
    label: 'Data Final',
    type: 'date',
    size: 4,
    required: false,
  };
  
  private dtIniAuxMoradiaField: Field = {
    name: 'DTINIVIGENCIA',
    label: 'Início validade',
    type: 'date',
    size: 4,
    required: false,
  };

  private dtFimAuxMoradiaField: Field = {
    name: 'DTFIMVIGENCIA',
    label: 'Fim validade',
    type: 'date',
    size: 4,
    required: false,
  };

  private get valorBeneficioField(): Field {
    const field = {
      name: 'VREVENTOFIXO',
      label: 'Salário',
      type: 'number',
      size: 4,
      required: false,
      onInput: this.fixField,
    };

    return field;
  }

  private get tipoAletaracaoBeneficioField(): Field {
    const field = {
      name: 'CDTIPOALTEVC',
      label: 'Tipo de alteração',
      type: 'select',
      valueField: 'value',
      descriptionField: 'name',
      size: 4,
      required: false,
      items: [
        {
          name: 'Inclusão',
          value: 'I',
        },
        {
          name: 'Exclusão',
          value: 'E',
        },
      ],
    };

    return field;
  }

  private get pessoaField(): Field {
    const field = {
      name: 'NRPESSOA',
      label: 'Pessoa',
      type: 'select',
      size: 4,
      required: false,
      items:this.fieldsData.pessoas
    };

    return field;
  }


  private get tituloRelatorioField(): Field {
    const field = {
      name: 'TITULORELATORIO',
      label: 'Título do Relatório',
      type: 'text',
      size: 6,
      required: false,
      isVisible: true
    };

    return field;
  }


  private get tipoBeneficioField(): Field {
    const field = {
      name: 'NRTPBENEFICIO',
      label: 'Tipo Benefício',
      descriptionField: 'DSTPBENEFICIO',
      valueField: 'NRTPBENEFICIO',
      type: 'select',
      size: 6,
      required: false,
      items:this.fieldsData.tiposBeneficio
    };

    return field;
  }

  private get dataInicioPagamentoField(): Field {
    const field = {
      name: 'DTINICIOPAG',
      label: 'Data Inicial de Pagamento',
      type: 'date',
      size: 6,
      required: false,
      isVisible: true
    };

    return field;
  }

  private get dataFimPagamentoField(): Field {
    const field = {
      name: 'DTFIMPAG',
      label: 'Data Final de Pagamento',
      type: 'date',
      size: 6,
      required: false,
      isVisible: true
    };

    return field;
  }

  private get dataPeriodoInicialField(): Field {
    const field = {
      name: 'DTPERIODOINICIAL',
      label: 'Data Inicial do Período',
      type: 'date',
      size: 6,
      required: false,
      isVisible: true
    };

    return field;
  }

  private get dataPeriodoFinalField(): Field {
    const field = {
      name: 'DTPERIODOFINAL',
      label: 'Data Final do Período',
      type: 'date',
      size: 6,
      required: false,
      isVisible: true
    };

    return field;
  }

  private get paginarPorEstruturasField(): Field {
    const field: Field = {
      name: 'PAGINARPORESTRUTURAS',
      label: 'Paginar por Estrutura Legal/Gerencial',
      type: 'select',
      valueField: 'value',
      descriptionField: 'name',
      isVisible: true,
      size: 6,
      items: [
        {
          name: 'Sim',
          value: 'S',
        },
        {
          name: 'Não',
          value: 'N',
        },
      ],
    };

    return field;
  }

  private get beneficioField(): Field {
    const field = {
      name: 'NRBENEFICIOM',
      label: 'Benefício',
      type: 'select',
      size: 4,
      descriptionField: 'NRDSBENEFICIO',
      valueField: 'NRBENEFICIOM',
      required: false,
      items:this.fieldsData.beneficios
    };

    return field;
  }

  private get qtdeBeneficioField(): Field {
    const field = {
      name: 'QTBENEFICIO',
      label: 'Qtde Benefício',
      type: 'number',
      size: 4,
      required: false,
    };

    return field;
  }

  private get dtIniBeneficioField(): Field {
    const field = {
      name: 'DTINSCBENEFICIARIO',
      label: 'Data de Início',
      type: 'date',
      size: 4,
      required: false,
    };

    return field;
  }

  private get dtFimBeneficioField(): Field {
    const field = {
      name: 'DTCANCBENEFICIARIO',
      label: 'Data Fim',
      type: 'date',
      size: 4,
      required: false,
    };

    return field;
  }

  private get qtdeDiasFeriasField(): Field {
    const field = {
      name: 'QTDIASFERIAS',
      label: 'Quantidade de dias',
      type: 'number',
      size: 4,
      required: false,
    };

    return field;
  }

  private get dtIniFeriasField(): Field {
    const field = {
      name: 'DTINIGOZOFERIAS',
      label: 'Data Inicio',
      type: 'date',
      size: 4,
      required: false,
    };

    return field;
  }

  private get dtFimFeriasField(): Field {
    const field = {
      name: 'DTFIMGOZOFERIAS',
      label: 'Data Fim',
      type: 'date',
      size: 4,
      required: false,
    };

    return field;
  }

  private get adiantamentoDecTercField(): Field {
    const field = {
      name: 'IDADIANT13SALAR',
      label: 'Adiantamento de 13°',
      type: 'select',
      valueField: 'value',
      descriptionField: 'name',
      size: 4,
      required: false,
      items: [
        {
          name: 'Sim',
          value: 'S',
        },
        {
          name: 'Não',
          value: 'N',
        },
      ],
    };

    return field;
  }
  
  private get tiposRelacionamentoField(): Field {
    const field = {
      name: 'NRTIPORELACIONA',
      label: 'Tipo de Relacionamento',
      type: 'autocomplete',
      descriptionField: 'NMTIPORELACIONA',
      valueField: 'NRTIPORELACIONA',
      size: 4,
      required: false,
      items: this.fieldsData.tiposRelacionamento,
    };

    return field;
  }

  private get dtNascimentoField(): Field {
    const field = {
      name: 'DTNASCIFUNDPARC',
      label: 'Data de Nascimento',
      type: 'select',
      valueField: 'value',
      descriptionField: 'name',
      size: 4,
      required: false,
      items: [
        {
          name: 'Feminino',
          value: 'F',
        },
        {
          name: 'Masculino',
          value: 'M',
        },
      ],
    };

    return field;
  }

  private get sexoField(): Field {
    const field = {
      name: 'IDSEXOPESSOA',
      label: 'Sexo',
      type: 'select',
      descriptionField: 'name',
      valueField: 'value',
      required: false,
      size: 4,
      items: [
        {
          name: 'Feminino',
          value: 'F',
        },
        {
          name: 'Masculino',
          value: 'M',
        },
      ],
    };

    return field;
  }
  
  private get transferenciaField(): Field {
    const field = {
      name: 'NRTPMOVTRANSFM',
      label: 'Transferência',
      descriptionField: 'NMTPMOVTRANSFH',
      valueField: 'NRTPMOVTRANSFM',
      type: 'autocomplete',
      size: 4,
      required: false,
      items: this.fieldsData.transferencias,
    };

    return field;
  }
  
  private get motivoTransferenciaField(): Field {
    const field = {
      name: 'NRMOTIVOTRANSF',
      label: 'Motivo de Transferência',
      descriptionField: 'NMMOTIVOTRANSF',
      valueField: 'NRMOTIVOTRANSF',
      type: 'autocomplete',
      size: 4,
      required: false,
      items: this.fieldsData.motivosTransferencia,
    };

    return field;
  }
  
  private get tipoAlteracaoSalarioField(): Field {
    const field = {
      name: 'NRTIPOALTERA',
      label: 'Tipo de Alteração',
      size: 4,
      type: 'autocomplete',
      valueField: 'NRTIPOALTERA',
      descriptionField: 'NMTIPOALTERA',
      items: this.fieldsData.tiposAlteraSal,
      required: false,
    };

    return field;
  }

  private get dtIniMovimentacaoField(): Field {
    const field = {
      name: 'DTINIMOVIMENT',
      label: 'Data de Início',
      size: 4,
      type: 'date',
      required: false,
    };

    return field;
  }

  private get dtFimMovimentacaoField(): Field {
    const field = {
      name: 'DTFIMMOVIMENT',
      label: 'Data Fim',
      size: 4,
      type: 'date',
      required: false,
    };

    return field;
  }

  private get estruturaGerencialItemField(): Field {
    const descField = this.user.dp ? 'NRNMESTRUTURA' : 'NMESTRUTURA';
    const field = {
      name: 'NRESTRUTGEREN_ITEM',
      valueField: 'NRESTRUTURAM',
      descriptionField: descField,
      label: 'Estrutura Gerencial (Item)',
      type: 'autocomplete',
      size: 4,
      items: this.fieldsData.estruturasGerenciais,
    };

    return field;
  }

  private get estruturaLegalItemField(): Field {
    const field: Field = {
      name: 'NRESTRUTLEGAL_ITEM',
      valueField: 'NRESTRUTURAM',
      descriptionField: 'NRNMESTRUTURA',
      label: 'Estrutura Legal (Item)',
      type: 'autocomplete',
      size: 4,
      items: this.fieldsData.estruturasLegais,
    };

    return field;
  }

  private get valorReembolsoField(): Field {
    const field: Field = {
      name: 'VRREEMBOLSO',
      label: 'Valor do Reembolso',
      type: 'number',
      size: 4,
      onInput: this.fixField,
    };

    return field;
  }

  private get treinamentoInternoField(): Field {
    const field: Field = {
      name: 'IDTREINAMENTOINT',
      label: 'Treinamento Interno',
      type: 'select',
      valueField: 'value',
      descriptionField: 'name',
      size: 4,
      items: [
        {
          name: 'Sim',
          value: 'S',
        },
        {
          name: 'Não',
          value: 'N',
        },
      ],
    };

    return field;
  }

  private get nomeTreinamentoField(): Field {
    const field: Field = {
      name: 'NMTREINAMENTO',
      label: 'Nome',
      type: 'text',
      size: 4,
    };

    return field;
  }

  private get cursoTreinamentoField(): Field {
    const field: Field = {
      name: 'NRCURSO',
      label: 'Curso',
      type: 'autocomplete',
      descriptionField: 'NMCURSO',
      valueField: 'NRCURSO',
      size: 4,
      items: this.fieldsData.cursos,
    };

    return field;
  }

  private get perfilAcessoField(): Field {
    const field: Field = {
      name: 'NRPERFACESAPROV',
      label: 'Perfil de Aprovação',
      type: 'autocomplete',
      descriptionField: 'NMPERFILACESSO',
      valueField: 'NRPERFILACESSO',
      size: 4,
      items: this.fieldsData.perfisAcesso,
    };

    return field;
  }

  private get metodoTreinamentoField(): Field {
    const field: Field = {
      name: 'NRMETODOTRE',
      label: 'Método',
      type: 'autocomplete',
      descriptionField: 'NMMETODOTRE',
      valueField: 'NRMETODOTRE',
      size: 4,
      items: this.fieldsData.metodos,
    };

    return field;
  }

  private get perfilExecTreinamentoField(): Field {
    const field: Field = {
      name: 'NRPERFACESEXEC',
      label: 'Perfil de Execução',
      type: 'autocomplete',
      descriptionField: 'NMPERFILACESSO',
      valueField: 'NRPERFILACESSO',
      size: 4,
      items: this.fieldsData.perfisAcesso,
    };

    return field;
  }

  private get dtIniTreinamentoField(): Field {
    const field: Field = {
      name: 'DTINIPLANEJADOTRE',
      label: 'Início Planejado',
      type: 'date',
      size: 4,
    };

    return field;
  }

  private get dtFimTreinamentoField(): Field {
    const field: Field = {
      name: 'DTFIMPLANEJADOTRE',
      label: 'Fim Planejado',
      type: 'date',
      size: 4,
    };

    return field;
  }

  private get tipoAlteracaoField(): Field {
    const field: Field = {
      name: 'CDTIPOALTEVC',
      label: 'Tipo de Alteração',
      type: 'select',
      valueField: 'value',
      descriptionField: 'name',
      size: 4,
      items: [
        {
          name: 'Inclusão',
          value: 'I',
        },
        {
          name: 'Exclusão',
          value: 'E',
        },
      ],
    };

    return field;
  }

  private get tipoValeCombustivelField(): Field {
    const field: Field = {
      name: 'CDTIPOVC',
      label: 'Tipo',
      type: 'select',
      valueField: 'value',
      descriptionField: 'name',
      size: 4,
      items: [
        {
          name: 'Por KM',
          value: 'K',
        },
        {
          name: 'Por Valor',
          value: 'V',
        },
      ],
    };

    return field;
  }

  private get qntCombustivelField(): Field {
    const field: Field = {
      name: 'QTBENEFICIO',
      label: this.formRow.CDTIPOVC == 'V' ? 'Qtd. Benefício' : 'Qtd. por KM',
      type: 'number',
      size: 4,
    };

    return field;
  }

  private get tipoBeneficioCombustivelField(): Field {
    const field: Field = {
      name: 'NRBENEFICIOM',
      label: 'Tipo do vale',
      type: 'autocomplete',
      size: 4,
      descriptionField: 'NRDSBENEFICIO',
      valueField: 'NRBENEFICIOM',
      items: this.fieldsData.beneficiosCombustivel
    };

    return field;
  }

  private get dataIniCombustivelField(): Field {
    const field: Field = {
      name: 'DTINSCBENEFICIARIO',
      label: 'Data Inscrição',
      type: 'date',
      size: 4,
    };

    return field;
  }

  private get dataFimCombustivelField(): Field {
    const field: Field = {
      name: 'DTCANCBENEFICIARIO',
      label: 'Data Validade',
      type: 'date',
      size: 4,
    };

    return field;
  }

  private get tipoPeriodoBeneficioField(): Field {
    const field: Field = {
      name: 'TPPERIODOBENEF',
      label: 'Período Benefício',
      type: 'autocomplete',
      size: 4,
      descriptionField: 'name',
      valueField: 'value',
      items: [
        {
          name: 'Mensal',
          value: 'MENSAL',
        },
        {
          name: 'Diário',
          value: 'DIARIO',
        },
      ],
    };

    return field;
  }

  private get tipoBeneficioManutencaoField(): Field {
    const field: Field = {
      name: 'NRBENEFICIOM',
      label: 'Tipo do vale',
      type: 'autocomplete',
      size: 4,
      descriptionField: 'NRDSBENEFICIO',
      valueField: 'NRBENEFICIOM',
      items: this.fieldsData.beneficiosManutencao
    };

    return field;
  }

  private get qntBeneficioManutencaoField(): Field {
    const field: Field = {
      name: 'QTBENEFICIO',
      label: 'Qtd. Benefício',
      type: 'number',
      size: 4,
    };

    return field;
  }

  private get dtAlteValeTransporteField(): Field {
    const field: Field = {
      name: 'DTALTELINHAVINC',
      label: 'Data de Alteração',
      type: 'date',
      size: 4,
    };

    return field;
  }

  private get linhaTransporteField(): Field {
    const field: Field = {
      name: 'NRLINHATRANSP',
      label: 'Linha',
      type: 'autocomplete',
      valueField: 'NRLINHATRANSP',
      descriptionField: 'NRDSLINHATRANSP',
      size: 4,
      items: this.fieldsData.linhas,
    };

    return field;
  }

  private get tipoLinhaTransporteField(): Field {
    const field: Field = {
      name: 'NRTIPOLINHAVINC',
      label: 'Tipo de Linha',
      type: 'autocomplete',
      valueField: 'NRTIPOLINHAVINC',
      descriptionField: 'DSTIPOLINHAVINC',
      size: 4,
      items: this.fieldsData.tiposLinha,
    };

    return field;
  }

  private get vrTarifaTransporteField(): Field {
    const field: Field = {
      name: 'VRTARIFA',
      label: 'Valor da Tarifa',
      type: 'number',
      size: 4,
      onInput: this.fixField,
    };

    return field;
  }

  private get qntdTransporteField(): Field {
    const field: Field = {
      name: 'QTLINHATARIFA',
      label: 'Quantidade',
      type: 'number',
      size: 4,
    };

    return field;
  }
  
  private get tipoValeTransporteField(): Field {
    const field: Field = {
      name: 'CDTIPOALTEVT',
      label: 'Tipo de Alteração',
      type: 'select',
      valueField: 'value',
      descriptionField: 'name',
      size: 4,
      items: [
        {
          name: 'Por KM',
          value: 'K',
        },
        {
          name: 'Por Valor',
          value: 'V',
        },
      ],
    };

    return field;
  }


  private emptyField: Field = {
    size: 6,
    type: 'empty',
  };

  private canViewReports = true;
  // #endregion

  // #region [ COMPUTED ]
  private get formFields(): Field[] {
    const fields: Field[] = [
      this.selectReportField,
    ];

    if (this.selectedReport) {
      let reportFields = this.selectedReport.fields;

      if (this.user.dp && this.selectedReport.fieldsDP) {
        reportFields = this.selectedReport.fieldsDP;
      }

      fields.push(...reportFields);
    }

    return fields;
  }


  @Watch('estruturaGerencialAtual')
  private estruturaGerencialAtualOnChange() {
    const estruturasNotVisibleOnReport = !this.currentReportHasEstrutLegalField || !this.currentReportHasEstrutGerenField;
    if (estruturasNotVisibleOnReport) {
      this.getVinculosByEstruturaField();
    }

    this.preencheEstruturaSolicitacaoReport();
  }

  private get selectedReport() {
    const selectedReportName = this.formRow.reportName;

    if (!selectedReportName) {
      return null;
    }

    const selectedReport = this.reports.find((report) => {
      const reportName = report.value;
      return selectedReportName === reportName;
    });

    return selectedReport;
  }

  private get selectedReportName(): string {
    const value = this.selectedReport ?
      this.selectedReport.value :
      null;

    return value;
  }

  private get breakpoint(): string {
    return this.$vuetify.breakpoint.name;
  }

  private get iframeSize() {
    const sizes: any = {
      xs: {
        width: 300,
        height: 500,
      },
      sm: {
        width: 500,
        height: 500,
      },
      md: {
        width: 900,
        height: 500,
      },
      lg: {
        width: 1150,
        height: 500,
      },
      xl: {
        width: 1500,
        height: 500,
      },
    };

    const currentSize = sizes[this.breakpoint];

    return currentSize;
  }

  private get reportDataUrl(): string {
    if (!this.type || !this.base64) {
      return '';
    }

    const dataUrl = FileUtils.getFullBase64(this.base64, this.type);
    return dataUrl;
  }

  private get reportCardClasses() {
    const classes = {
      opened: this.reportLink !== '',
    };

    return classes;
  }

  private get reportIsVisible(): boolean {
    if (this.showReport && this.reportLink !== '') {
      return true;
    } else {
      return false;
    }
  }

  private get reportCardElevation(): number {
    return this.reportIsVisible ? 4 : 0;
  }

  private get iframeLink(): string {
    const link = this.reportIsVisible ?
      this.reportDataUrl :
      '';

    return link;
  }

  public get estruturaGerencialField(): Field {
    const descField = this.user.dp ? 'NRNMESTRUTURA' : 'NMESTRUTURA';
    const field = {
      name: 'NRESTRUTGEREN',
      valueField: 'NRESTRUTURAM',
      descriptionField: descField,
      label: 'Estrutura Gerencial',
      type: 'autocomplete',
      size: 6,
      required: this.estruturaGerencialObrigatorio,
      items: this.fieldsData.estruturasGerenciais,
      onInput: () => {
        this.getVinculosByEstruturaField(), 
        this.loadSolicitacoes()
      }
    };

    return field;
  }

  public get estruturaLegalField(): Field {
    const field: Field = {
      name: 'NRESTRUTLEGAL',
      valueField: 'NRESTRUTURAM',
      descriptionField: 'NRNMESTRUTURA',
      label: 'Estrutura Legal',
      type: 'autocomplete',
      size: 6,
      required: this.isEstruturaSupSelected(),
      items: this.fieldsData.estruturasLegais,
      onInput: () => {
        this.getVinculosByEstruturaField(), 
        this.loadSolicitacoes()
      }
    };

    return field;
  }

  public get vinculosField(): Field {
    const field: Field = {
      name: 'NRVINCULOM',
      label: 'Vínculo',
      type: 'autocomplete',
      valueField: 'NRVINCULOM',
      descriptionField: 'NMVINCULOM',
      size: 6,
      required: true,
      items: this.fieldsData.vinculos,
      outData: {
        NRVINCULOM: 'NRVINCULOM',
        NMVINCULOM: 'NMVINCULOM',
      },
      onInput: this.loadSolicitacoes,
    };

    return field;
  }

  private get tipoVinculoField(): Field {
    const field: Field = {
      name: 'NRTIPOVINCULOM',
      label: 'Tipo de Vínculo',
      type: 'select',
      valueField: 'NRTIPOVINCULOM',
      descriptionField: 'NMTIPOVINCULOH',
      size: 6,
      required: true,
      items: this.fieldsData.tiposVinculo,
    };

    return field;
  }

  private get solicitacoesField(): Field {
    const field: Field = {
      name: 'NRSOLICITACAO',
      label: 'Solicitação',
      type: 'autocomplete',
      valueField: 'NRSOLICITACAO',
      descriptionField: 'NRSOLICITACAOVINCULO',
      size: 6,
      required: false,
      items: this.fieldsData.solicitacoes,
    };

    return field;
  }

  public get tipoHierarquiaField(): Field {
    const field: Field = {
      name: 'NRTIPOHIERARQ',
      label: 'Tipo de Hierarquia',
      type: 'autocomplete',
      valueField: 'NRTIPOHIERARQORG',
      descriptionField: 'NMTIPOHIERARQORG',
      isVisible: false,
      size: 6,
      items: this.fieldsData.tiposHierarquia,
      onInput: this.tipoHierarquiaOnInput,
      outData: {
        NRTIPOESTRUTSUP: 'NRTIPOESTRUTSUP',
      },
    };

    return field;
  }

  public get estruturaSuperiorField(): Field {
    const field = {
      name: 'NRESTRUTSUPERIOR',
      label: 'Estrutura Superior',
      type: 'autocomplete',
      valueField: 'NRESTRUTURAM',
      descriptionField: 'NMESTRUTURA',
      size: 6,
      items: this.fieldsData.estruturasSuperiores,
      readonly: Util.isUndefinedOrNull(this.formRow.NRTIPOHIERARQ),
    };

    return field;
  }

  get estruturaSuperiorOperadorField(): Field {
    const field = {
      name: 'NRESTRUTSUPERIOR',
      label: 'Estrutura Superior',
      type: 'autocomplete',
      valueField: 'NRESTRUTURAM',
      descriptionField: 'NMESTRUTURA',
      size: 6,
      items: this.fieldsData.estruturasSuperioresOperador,
      readonly: false,
      onInput: this.estrutSuperiorOnInput,
      required: false,
      outData: {
        NRTIPOESTRUTURA: 'NRTIPOESTRUTURA',
      }
    };

    return field;
  }

  private get bancoField(): Field {
    const field = {
      name: 'CDBANCO',
      label: 'Banco',
      type: 'autocomplete',
      valueField: 'CDBANCO',
      descriptionField: 'NMBANCO',
      size: 6,
      items: this.fieldsData.bancos,
    };

    return field;
  }

  private get apenasEventoField(): Field {
    const field = {
      name: 'NREVENTOM',
      label: 'Apenas Recibos de Pagamentos com este evento:',
      type: 'autocomplete',
      valueField: 'NREVENTOM',
      descriptionField: 'NMEVENTOH',
      size: 6,
      items: this.fieldsData.eventos,
    };

    return field;
  }

  private get naoMarcacaoField(): Field {
    const field = {
      name: 'NAOEXIGIMARC',
      label: 'Não exigir marcações',
      type: 'select',
      valueField: 'value',
      descriptionField: 'name',
      size: 6,
      items: [
        {
          value: 'S',
          name: 'Sim',
        },
        {
          value: 'N',
          name: 'Não',
        },
      ],
    };

    return field;
  }

  private get comAssinaturaField(): Field {
    const field = {
      name: 'COMASSINATURADIGITAL',
      label: 'Com Assinatura Digital',
      type: 'select',
      valueField: 'value',
      descriptionField: 'name',
      size: 6,
      items: [
        {
          value: 'S',
          name: 'Sim',
        },
        {
          value: 'N',
          name: 'Não',
        },
      ],
    };

    return field;
  }

  private get mostraRodapeField(): Field {
    const field = {
      name: 'MOSTRARINFO',
      label: 'Mostrar rodapé?',
      type: 'select',
      valueField: 'value',
      descriptionField: 'name',
      size: 6,
      items: [
        {
          value: 'S',
          name: 'Sim',
        },
        {
          value: 'N',
          name: 'Não',
        },
      ],
    };

    return field;
  }

  private get dataReciboField(): Field {
    const field: Field = {
      name: 'DTLIMITE',
      label: 'Data Recibo',
      type: 'date',
      size: 4,
      hideDatePicker: true,
    };

    return field;
  }

  private get afastadosField(): Field {
    const field: Field = {
      name: 'VINCAFAST',
      label: 'Exibir Vínculos Afastados',
      type: 'select',
      valueField: 'value',
      descriptionField: 'description',
      items: [
        {
          value: 'S',
          description: 'Sim',
        },
        {
          value: 'N',
          description: 'Não',
        },
      ],
    };

    return field;
  }

  private get omitirAgrupField(): Field {
    const field: Field = {
      name: 'OMITIRAGRUP',
      label: 'Omitir Agrupamento',
      type: 'select',
      valueField: 'value',
      descriptionField: 'description',
      items: [
        {
          value: 'S',
          description: 'Sim',
        },
        {
          value: 'N',
          description: 'Não',
        },
      ],
    };

    return field;
  }

  public get zebradoField(): Field {
    const field: Field = {
      name: 'ZEBRADO',
      label: 'Zebrado',
      type: 'checkbox',
      valueToTrue: 'S',
      valueToFalse: 'N',
    };

    return field;
  }

  private get loteVinculosField(): Field {
    const field: Field = {
      name: 'NRLOTEVINC',
      label: 'Lote de Vínculos',
      type: 'autocomplete',
      valueField: 'NRLOTEVINC',
      descriptionField: 'NMLOTEVINC',
      size: 6,
      items: this.fieldsData.loteVinculos,
      outData: {
        NRLOTEVINC: 'NRLOTEVINC',
        NMLOTEVINC: 'NMLOTEVINC',
      },
    };

    return field;
  }

  private get reports(): ReportType[] {
    return [
      {
        name: 'Folha de Ponto',
        value: 'folha_ponto',
        fields: [
          this.dtCompetenciaField,
          this.vinculosField,
        ],
        onSelection: this.informeRendimentosOnSelection,
        params: [
          {
            fieldName: 'NRVINCULOM',
            param: 'P_NRVINCULOM',
            required: true,
          },
          {
            fieldName: 'DTMESCOMPETENCIA',
            param: 'P_COMPETENCIA',
            required: true,
          },
          {
            fieldName: 'DTMESCOMPETENCIA',
            param: 'P_COMPPONTO',
            required: true,
          },
        ],
      },
      {
        name: 'Demonstrativo de Folha de Ponto',
        value: 'ponto_demonstrativo',
        defaultRow: {
          NAOEXIGIMARC: 'N',
          NRESTRUTLEGAL: null,
          NRTIPOVINCULOM: '1',
        },
        sendEmptyParams: true,
        onSelection: this.loadDemonstrativoPontoOnSelection,
        fields: [
          this.dtCompetenciaField,
          this.periodoApuracao,
          this.estruturaSuperiorOperadorField,
          {
            ...this.estruturaGerencialField,
            required: this.isEstruturaSupSelected(),
          },
          {
            ...this.vinculosField,
            onInput: this.pontoDemonstrativoVinculoOnInput,
            required: this.obrigarFiltroVinculoAssinatura,
          },
          this.naoMarcacaoField,
          this.comAssinaturaField,
          this.tipoVinculoField,
        ] as Field[],
        fieldsDP:[
          this.dtCompetenciaField,
          this.periodoApuracao,
          {
            ...this.estruturaSuperiorOperadorField,
            size: 6,
          },
          {
            ...this.estruturaLegalField,
            size: 6,
          },
          this.estruturaGerencialField,
          {
            ...this.vinculosField,
            onInput: this.pontoDemonstrativoVinculoOnInput,
            required: this.obrigarFiltroVinculoAssinatura,
          },
          this.naoMarcacaoField,
          this.comAssinaturaField,
          this.tipoVinculoField,
        ],
        params: [
          {
            fieldName: 'NRVINCULOM',
            param: 'P_VINCULO',
            defaultValue:'',
          },
          {
            fieldName: 'DTMESCOMPETENCIA',
            param: 'P_COMPETENCIA',
            required: true,
          },
          {
            fieldName: 'NRPERIODOAPURACAO',
            param: 'P_PERIODO',
            required: true,
          },
          {
            fieldName: 'NAOEXIGIMARC',
            param: 'P_NAOEXIGIMARC',
            default: 'N',
          },
          {
            fieldName: 'COMASSINATURADIGITAL',
            param: 'P_COMASSINATURADIGITAL',
            default: 'N',
          },
          {
            fieldName: 'NRTIPOVINCULOM',
            param: 'P_TPVINCULO',
            default: '',
            required: true,
          },
          {
            fieldName: 'NRESTRUTLEGAL',
            param: 'P_ESTRUTLEGAL',
            required: this.isEstruturaSupSelected(),
          },
          {
            fieldName: 'NRESTRUTGEREN',
            param: 'P_ESTRUTGEREN',
          },
          {
            fieldName: 'NRESTRUTSUPERIOR',
            param: 'P_NRESTRUTSUP',
            defaultValue: '',
          },
          {
            fieldName: 'NRTIPOHIERARQ',
            param: 'P_NRTIPOHIERARQORG',
            required: !this.isEstruturaSupSelected(),
            defaultValue: '',
          },
        ],
      },
      {
        name: 'Demonstrativo de Folha de Ponto Analítico',
        value: 'ponto_demonstrativo_analitico',
        defaultRow: {
          NAOEXIGIMARC: 'N',
          NRESTRUTLEGAL: null,
        },
        onSelection: this.loadDemonstrativoPontoAnaliticoOnSelection,
        sendEmptyParams: true,
        fields: [
          this.dtCompetenciaField,
          this.periodoApuracao,
          {
            ...this.estruturaSuperiorOperadorField,
            size: 6,
          },
          {
            ...this.estruturaGerencialField,
            required: this.isEstruturaSupSelected(),
            size: 6,
          }, 
          {
            ...this.vinculosField,
            onInput: this.pontoDemonstrativoVinculoOnInput,
            required: false,
          },
          this.naoMarcacaoField,
          this.tipoVinculoField,
        ] as Field[],
        fieldsDP:[
          this.dtCompetenciaField,
          this.periodoApuracao,
          {
            ...this.estruturaSuperiorOperadorField,
            size: 6,
          },
          {
            ...this.estruturaLegalField,
            size: 6,
          },
          this.estruturaGerencialField,
          {
            ...this.vinculosField,
            onInput: this.pontoDemonstrativoVinculoOnInput,
            required:false,
          },
          this.naoMarcacaoField,
          this.tipoVinculoField,
        ],
        params: [
          {
            fieldName: 'NRVINCULOM',
            param: 'P_VINCULO',
            defaultValue:'',
          },
          {
            fieldName: 'DTMESCOMPETENCIA',
            param: 'P_COMPETENCIA',
            required: true,
          },
          {
            fieldName: 'NRPERIODOAPURACAO',
            param: 'P_PERIODO',
            required: true,
          },
          {
            fieldName: 'NAOEXIGIMARC',
            param: 'P_NAOEXIGIMARC',
            default: 'N',
          },
          {
            fieldName: 'NRTIPOVINCULOM',
            param: 'P_TPVINCULO',
            default: '',
            required: true,
          },
          {
            fieldName: 'NRESTRUTLEGAL',
            param: 'P_ESTRUTLEGAL',
            required: true,
          },
          {
            fieldName: 'NRESTRUTGEREN',
            param: 'P_ESTRUTGEREN',
          },
          {
            fieldName: 'NRESTRUTSUPERIOR',
            param: 'P_NRESTRUTSUP',
            required: !this.isEstruturaSupSelected(),
            defaultValue: '',
          },
          {
            fieldName: 'NRTIPOHIERARQ',
            param: 'P_NRTIPOHIERARQORG',
            required: !this.isEstruturaSupSelected(),
            defaultValue: '',
          },
        ],
      },
      {
        name: 'Recibo de Férias',
        value: 'recibo_ferias',
        onSelection: this.loadEstruturasSuperioresTipoHierarquiaInfo,
        restricted: true,
        fields: [
          { 
            ...this.estruturaSuperiorOperadorField,
            size: 8,
          },
          this.dtCompetenciaField,
          {
            ...this.vinculosField,
            required: this.isEstruturaSupSelected(),
            size: 8,
          },
        ],
        params: [
          {
            fieldName: 'NRVINCULOM',
            param: 'P_NRVINCULO',
            required: this.isEstruturaSupSelected(),
          },
          {
            fieldName: 'DTMESCOMPETENCIA',
            param: 'P_DTMESCOMPETENC',
            required: true,
          },
          {
            fieldName: 'NROCORRECAL',
            param: 'P_OCORRECAL',
            required: true,
            defaultValue: 1,
          },
          {
            fieldName: 'NRTPMODALIDCAL',
            param: 'P_MODALIDADECAL',
            required: true,
            defaultValue: 1,
          },
          {
            fieldName: 'IGNORAOCORR',
            param: 'P_IGNORAOCORR',
            required: true,
            defaultValue: 'S',
          },
          {
            fieldName: '2VIAS',
            param: 'P_2VIAS',
            required: true,
            defaultValue: 'N',
          },
          {
            fieldName: 'NRESTRUTSUPERIOR',
            param: 'P_NRESTRUTSUP',
            required: !this.isEstruturaSupSelected(),
            defaultValue: '',
          },
          {
            fieldName: 'NRTIPOHIERARQ',
            param: 'P_NRTIPOHIERARQ',
            required: !this.isEstruturaSupSelected(),
            defaultValue: '',
          },
        ],
      },
      {
        name: 'Analítico - DIRF',
        value: 'analitico_dirf',
        restricted: true,
        fields: [
          this.dtCompetenciaField,
        ],
        fieldsDP: [
          this.dtCompetenciaField,
          this.estruturaLegalField,
        ],
        params: [
          {
            fieldName: 'DTMESCOMPETENCIA',
            param: 'P_COMPETENCIA',
            required: true,
          },
          {
            fieldName: 'NRESTRUTLEGAL',
            param: 'P_ESTRUTURARESP',
            required: true,
          },
          {
            fieldName: 'NRVINCULOM',
            param: 'P_VINCULO',
            required: true,
          },
        ],
      },
      {
        name: 'Informe de Rendimentos - DIRF',
        value: 'informe_rendimentos',
        restricted: true,
        fields: [
          this.dtCompetenciaField,
          this.estruturaGerencialField,
          {
            ...this.vinculosField,
            required: false,
          },
          this.anoReferenciaField,
          this.anoCalendarioField,
        ],
        fieldsDP: [
          this.dtCompetenciaField,
          this.estruturaLegalField,
          this.estruturaGerencialField,
          {
            ...this.vinculosField,
            required: false,
          },
          this.anoReferenciaField,
          this.anoCalendarioField,
        ],
        onSelection: this.informeRendimentosOnSelection,
        beforeGeneration: this.informeRendimentosBeforeGeneration,
        params: [
          {
            fieldName: 'DTMESCOMPETENCIA',
            param: 'P_COMPETENCIA',
            required: true,
          },
          {
            fieldName: 'NRESTRUTLEGAL',
            param: 'P_ESTRUTURARESP',
            required: true,
          },
          {
            fieldName: 'NRESTRUTGEREN',
            param: 'P_ESTRUTGEREN',
          },
          {
            fieldName: 'NRVINCULOM',
            param: 'P_VINCULO',
          },
          {
            fieldName: 'NRANOREF',
            required: true,
            param: 'P_ANOREF',
          },
          {
            fieldName: 'NRANOCAL',
            required: true,
            param: 'P_ANOCALEN',
          },
        ],
      },
      {
        name: 'Recibo de Pagamento de Salário',
        value: 'demonstrativo_pagamento_via_unica',
        restricted: true,
        defaultRow: {
          NRTIPOMOVIMENT: '1',
          IGNORAOCORR: 'S',
          NRESTRUTLEGAL: null,
        },
        fields: [
          this.dtCompetenciaField,
          {
            ...this.tipoMovimentoField,
            size: 6,
          },
          {
            ...this.estruturaSuperiorOperadorField,
            size: 6,
          },
          this.estruturaGerencialField,
          {
            ...this.vinculosField,
            required: false,
          },
        ],
        fieldsDP: [
          this.dtCompetenciaField,
          this.tipoMovimentoField,
          {
            ...this.estruturaSuperiorOperadorField,
            size: 6,
          },
          this.estruturaLegalField,
          this.estruturaGerencialField,
          {
            ...this.vinculosField,
            required: false,
          },
          this.bancoField,
          this.ignorarOcorrField,
          this.apenasEventoField,
          this.observacaoField,
        ],
        onSelection: this.reciboPagamentoOnSelection,
        beforeGeneration: this.reciboPagamentoBeforeGeneration,
        params: [
          {
            fieldName: 'NRVINCULOM',
            param: 'P_NRVINCULO',
          },
          {
            fieldName: 'DTMESCOMPETENCIA',
            param: 'P_COMPETENCIA',
            required: true,
          },
          {
            fieldName: 'NRESTRUTLEGAL',
            param: 'P_NRESTRUTLEGAL',
          },
          {
            fieldName: 'NRESTRUTGEREN',
            param: 'P_NRESTRUTGEREN',
          },
          {
            fieldName: 'NRTIPOMOVIMENT',
            param: 'P_NRTIPOMOVIMENT',
            required: true,
          },
          {
            fieldName: 'NRTIPOHIERARQ',
            param: 'P_NRTIPOHIERARQ',
          },
          {
            fieldName: 'NRESTRUTSUPERIOR',
            param: 'P_NRESTRUTSUP',
          },
          {
            fieldName: 'CDBANCO',
            param: 'P_CDBANCO',
          },
          {
            fieldName: 'NREVENTOM',
            param: 'P_EVENTO',
            defaultValue: 3035,
          },
          {
            fieldName: 'IGNORAOCORR',
            param: 'P_IGNORAOCORR',
            defaultValue: 'S',
          },
          {
            fieldName: 'DSOBSERVACAO',
            param: 'P_OBSERVACAO',
          },
          {
            fieldName: 'NROCORRECAL',
            param: 'P_OCORRECAL',
            required: true,
            defaultValue: 1,
          },
          {
            fieldName: 'NRTPMODALIDCAL',
            param: 'P_NRTPMODALIDCAL',
            required: true,
            defaultValue: 1,
          },
          {
            fieldName: 'NRESTRUTSUPERIOR',
            param: 'P_NRESTRUTSUP',
            required: !this.isEstruturaSupSelected(),
            defaultValue: '',
          },
          {
            fieldName: 'NRTIPOHIERARQ',
            param: 'P_NRTIPOHIERARQ',
            required: !this.isEstruturaSupSelected(),
            defaultValue: '',
          },
        ],
      },
      {
        name: 'Ficha de EPI',
        value: 'ficha_epi',
        fields: [
          this.dtCompetenciaField,
          {
            ...this.emptyField,
            size: 3
          },
          {
            ...this.estruturaSuperiorOperadorField,
            size: 6,
          },
          { 
            ...this.estruturaGerencialField, 
            required: this.isEstruturaSupSelected(),
            size: 6,
          },
          this.dtInicioField,
          this.dtFimField,
          this.dtDocumentoField,
          { 
            ...this.vinculosField,
            required: this.obrigarFiltroVinculoAssinatura,
          },
          this.mostraRodapeField,
          this.comAssinaturaField,
        ],
        fieldsDP: [
          this.dtCompetenciaField,
          {
            ...this.estruturaSuperiorOperadorField,
            size: 4,
          },
          this.estruturaLegalField,
          this.estruturaGerencialField,
          this.dtInicioField,
          this.dtFimField,
          this.dtDocumentoField,
          { 
            ...this.vinculosField,  
            required: this.obrigarFiltroVinculoAssinatura,
          },
          this.mostraRodapeField,
          this.comAssinaturaField,
        ],
        onSelection: this.reciboPagamentoOnSelection,
        params: [
          {
            fieldName: 'DTMESCOMPETENCIA',
            param: 'P_COMPETENCIA',
            required: true,
          },
          {
            fieldName: 'NRESTRUTLEGAL',
            param: 'P_ESTRUTLEGAL',
          },
          {
            fieldName: 'NRESTRUTGEREN',
            param: 'P_ESTRUTGEREN',
          },
          {
            fieldName: 'NRTIPOHIERARQ',
            param: 'P_NRTIPOHIERARQ',
          },
          {
            fieldName: 'NRESTRUTSUPERIOR',
            param: 'P_NRESTRUTSUP',
          },
          {
            fieldName: 'NRVINCULOM',
            param: 'P_VINCULO',
          },
          {
            fieldName: 'NMVINCULOM',
            param: 'P_NMVINCULOM',
          },
          {
            fieldName: 'DTINICIO',
            param: 'P_INICIO',
          },
          {
            fieldName: 'DTFIM',
            param: 'P_FINAL',
          },
          {
            fieldName: 'DTDOCUMENTO',
            param: 'P_DTDOCUMENTO',
          },
          {
            fieldName: 'MOSTRARINFO',
            param: 'P_MOSTRARINFO',
          },
          {
            fieldName: 'NRESTRUTSUPERIOR',
            param: 'P_NRESTRUTSUP',
            required: !this.isEstruturaSupSelected(),
            defaultValue: '',
          },
          {
            fieldName: 'NRTIPOHIERARQ',
            param: 'P_NRTIPOHIERARQ',
            required: !this.isEstruturaSupSelected(),
            defaultValue: '',
          },
          {
            fieldName: 'COMASSINATURADIGITAL',
            param: 'P_COMASSINATURADIGITAL',
            default: 'N',
          },
        ],
      },
      {
        name: 'Ficha de Controle de Entrega de EPI e Treinamento de Uso',
        value: 'controle_entrega_epi',
        fields: [
          this.dtCompetenciaField,
          { 
            ...this.emptyField, 
            size: 4,
          },
          { 
            ...this.estruturaGerencialField, 
            required: true, 
            size: 4,
          },
          { 
            ...this.vinculosField,  
            required: this.obrigarFiltroVinculoAssinatura,
            size: 4,
          },
          { 
            ...this.tipoVinculoField, 
            required:false, 
            size: 4
          },
          this.dtInicioField,
          this.dtFimField,
          this.dtDocumentoField,
          this.comAssinaturaField,
        ],
        fieldsDP: [
          this.dtCompetenciaField,
          this.estruturaLegalField,
          this.estruturaGerencialField,
          { 
            ...this.vinculosField,  
            required: this.obrigarFiltroVinculoAssinatura,
          },
          { 
            ...this.tipoVinculoField, 
            required: false,
          },
          { 
            ...this.dtInicioField, 
            size: 4,
          },
          { 
            ...this.dtFimField, 
            size: 4,
          },
          { 
            ...this.dtDocumentoField, 
            size: 4,
          },
          this.comAssinaturaField,
        ],
        onSelection: this.carregaTiposVinculo,
        params: [
          {
            fieldName: 'DTMESCOMPETENCIA',
            param: 'P_COMPETENCIA',
            required: true,
          },
          {
            fieldName: 'NRESTRUTLEGAL',
            param: 'P_ESTRUTLEGAL',
          },
          {
            fieldName: 'NRESTRUTGEREN',
            param: 'P_ESTRUTGEREN',
          },
          {
            fieldName: 'NRVINCULOM',
            param: 'P_VINCULO',
          },
          {
            fieldName: 'NMVINCULOM',
            param: 'P_NMVINCULOM',
          },
          {
            fieldName: 'NRTIPOVINCULOM',
            param: 'P_TIPOVINCULO',
          },
          {
            fieldName: 'DTINICIO',
            param: 'P_DTINICIO',
          },
          {
            fieldName: 'DTFIM',
            param: 'P_DTFINAL',
          },
          {
            fieldName: 'DTDOCUMENTO',
            param: 'P_DATADOCUMENTO',
          },
          {
            fieldName: 'MOSTRARINFO',
            param: 'P_MOSTRARINFO',
          },
          {
            fieldName: 'COMASSINATURADIGITAL',
            param: 'P_COMASSINATURADIGITAL',
            default: 'N',
          },
        ],
      },
      {
        name: 'Relatório de Absenteísmo',
        value: 'absenteismo',
        defaultRow: {
          NRESTRUTLEGAL: null,
        },
        sendEmptyParams: true,
        onSelection: this.loadEstruturasSuperioresTipoHierarquiaInfo,
        fields: [
          this.dtCompetenciaField,
          {
            ...this.emptyField,
            size: 4,
          },
          {
            ...this.estruturaSuperiorOperadorField,
            size: 6,
          },
          { 
            ...this.estruturaGerencialField, 
            required: this.isEstruturaSupSelected(),
            size: 6,
          },
          { 
            ...this.periodoApuracao, 
            size: 6 
          },
          {
            ...this.vinculosField,
            onInput: this.pontoDemonstrativoVinculoOnInput,
            required: false,
          },
        ] as Field[],
        fieldsDP: [
          this.dtCompetenciaField,
          {
            ...this.emptyField,
            size: 4,
          },
          {
            ...this.estruturaSuperiorOperadorField,
            size: 6,
          },
          {
            ...this.estruturaLegalField,
            size: 6,
          },
          this.estruturaGerencialField,
          {
            ...this.vinculosField,
            onInput: this.pontoDemonstrativoVinculoOnInput,
            required: false,
          },
          { 
            ...this.periodoApuracao, 
            size: 6,
          },
        ],
        params: [
          {
            fieldName: 'NRVINCULOM',
            param: 'P_VINCULO',
            required: true,
            defaultValue: '',
          },
          {
            fieldName: 'DTMESCOMPETENCIA',
            param: 'P_COMPETENCIA',
            required: true,
          },
          {
            fieldName: 'NRESTRUTLEGAL',
            param: 'P_ESTRUTLEGAL',
            required: true,
          },
          {
            fieldName: 'NRESTRUTGEREN',
            param: 'P_ESTRUTGEREN',
            required: true,
          },
          {
            fieldName: 'NRPERIODOAPURACAO',
            param: 'P_PERIODO',
            required: true,
          },
          {
            fieldName: 'NRTIPOVINCULOM',
            param: 'P_TPVINCULO',
            default: '',
          },
          {
            fieldName: 'NRESTRUTSUPERIOR',
            param: 'P_NRESTRUTSUP',
            required: !this.isEstruturaSupSelected(),
            defaultValue: '',
          },
          {
            fieldName: 'NRTIPOHIERARQ',
            param: 'P_NRTIPOHIERARQ',
            required: !this.isEstruturaSupSelected(),
            defaultValue: '',
          },
        ],
      },
      {
        name: 'Saldo de Banco de Horas',
        value: 'saldo_banco_horas',
        defaultRow: {
          NRESTRUTLEGAL: null,
        },
        sendEmptyParams: true,
        fields: [
          this.dtCompetenciaField,
          { 
            ...this.estruturaGerencialField, 
            required: true,
          },
          this.emptyField,
          this.periodoApuracao,
          {
            ...this.vinculosField,
            onInput: this.pontoDemonstrativoVinculoOnInput,
            required: false,
          },
        ] as Field[],
        fieldsDP: [
          this.dtCompetenciaField,
          this.estruturaLegalField,
          this.estruturaGerencialField,
          this.periodoApuracao,
          {
            ...this.vinculosField,
            onInput: this.pontoDemonstrativoVinculoOnInput,
            required: false,
          },
        ],
        params: [
          {
            fieldName: 'NRVINCULOM',
            param: 'P_VINCULO',
            required: true,
            defaultValue: '',
          },
          {
            fieldName: 'DTMESCOMPETENCIA',
            param: 'P_COMPETENCIA',
            required: true,
          },
          {
            fieldName: 'NRESTRUTLEGAL',
            param: 'P_ESTRUTLEGAL',
            required: true,
          },
          {
            fieldName: 'NRESTRUTGEREN',
            param: 'P_ESTRUTGEREN',
            required: true,
          },
          {
            fieldName: 'NRPERIODOAPURACAO',
            param: 'P_PERIODO',
            required: true,
          },
          {
            fieldName: 'NRTIPOVINCULOM',
            param: 'P_TPVINCULO',
            default: '',
          },
        ],
      },
      {
        name: 'Previsão de Férias',
        value: 'previsao_ferias',
        defaultRow: {
          NRESTRUTLEGAL: this.user.nrestrutlegal || null,
          VINCAFAST: 'S',
        },
        sendEmptyParams: true,
        onSelection: this.previsaoFeriasOnSelection,
        beforeGeneration: this.previsaoFeriasBeforeGeneration,
        fields: [
          this.dtCompetenciaField,
          {
            ...this.emptyField,
            size: 4,
          },
          {
            ...this.estruturaSuperiorOperadorField,
            size: 6,
          },
          {
            ...this.estruturaGerencialField,
            size: 6,
          },
          {
            ...this.vinculosField,
            required: false,
            size: 4,
          },
          this.dataReciboField,
          this.afastadosField,
          this.omitirAgrupField,
          this.zebradoField,
        ] as Field[],
        fieldsDP: [
          this.dtCompetenciaField,
          {
            ...this.estruturaSuperiorOperadorField,
            size: 6,
          },
          {
            ...this.estruturaLegalField,
            size: 6,
          },
          this.estruturaGerencialField,
          {
            ...this.vinculosField,
            required: false,
            size: 6,
          },
          this.dataReciboField,
          this.afastadosField,
          this.omitirAgrupField,
          this.zebradoField,
        ],
        params: [
          {
            fieldName: 'DTMESCOMPETENCIA',
            param: "P_COMPETENCIA",
            required: true
          },
          {
            fieldName: 'NRESTRUTLEGAL',
            param: "P_ESTRUTLEGAL"
          },
          {
            fieldName: 'NRESTRUTGEREN',
            param: "P_ESTRUTGEREN"
          },
          {
            fieldName: 'NRVINCULOM',
            param: "P_NRVINCULO"
          },
          {
            fieldName: 'NRTIPOHIERARQ',
            param: "P_HIERARQUIA"
          },
          {
            fieldName: 'DTLIMITE',
            param: "P_DATALIMITE"
          },
          {
            fieldName: 'VINCAFAST',
            param: "P_VINCAFAST",
            valueField: "S"
          },
          {
            fieldName: 'OMITIRAGRUP',
            param: "P_OMITIRAGRUP"
          },
          {
            fieldName: 'ZEBRADO',
            param: "ZEBRADO"
          },
          {
            fieldName: 'NRESTRUTSUPERIOR',
            param: 'P_NRESTRUTSUP',
            required: !this.isEstruturaSupSelected(),
            defaultValue: '',
          },
          {
            fieldName: 'NRTIPOHIERARQ',
            param: 'P_NRTIPOHIERARQ',
            required: !this.isEstruturaSupSelected(),
            defaultValue: '',
          },
        ],
      },
      {
        name: 'Quantidade de Dias Trabalhados',
        value: 'qtd_dias_trab',
        defaultRow: {
          NRTIPOVINCULOM: '1',
        },
        sendEmptyParams: true,
        beforeGeneration: this.diasTrabalhadosBeforeGeneration,
        onSelection: this.diasTrabalhadosOnSelection,
        fields: [
          this.dtCompetenciaField,
          this.estruturaGerencialField,
          {
            ...this.vinculosField,
            required: false,
          },
          this.tipoVinculoField,
          this.periodoApuracao,
        ] as Field[],
        fieldsDP: [
          this.dtCompetenciaField,
          {
            ...this.estruturaLegalField,
            required: false,
          },
          this.estruturaGerencialField,
          {
            ...this.vinculosField,
            required: false,
          },
          this.tipoVinculoField,
          this.periodoApuracao,
        ],
        params: [
          {
            fieldName: 'DTMESCOMPETENCIA',
            param: "P_COMPETENCIA",
            required: true
          },
          {
            fieldName: 'NRESTRUTLEGAL',
            param: "P_ESTRUTLEGAL"
          },
          {
            fieldName: 'NRESTRUTGEREN',
            param: "P_ESTRUTGEREN"
          },
          {
            fieldName: 'NRVINCULOM',
            param: "P_VINCULO"
          },
          {
            fieldName: 'NRPERIODOAPURACAO',
            param: "P_NRPERIODOAPURACAO"
          },
          {
            fieldName: 'NRTIPOVINCULOM',
            param: "P_TPVINCULO"
          },
        ],
      },
      {
        name: 'Ausência de Registros',
        value: 'ausencia_registros',
        defaultRow: {},
        hideGenerateAction: true,
        sendEmptyParams: true,
        onSelection: this.ausenciaMarcacoesOnSelection,
        fields: [
          this.dtCompetenciaField,
          this.dtDataField,
          {
            ...this.estruturaSuperiorOperadorField,
            size: 6
          },
          {
            ...this.estruturaGerencialField,
            required: this.isEstruturaSupSelected(),
            size: 6
          },
          {
            ...this.vinculosField,
            required: false
          },
        ] as Field[],
        fieldsDP: [
          this.dtCompetenciaField,
          this.dtDataField,
          {
            ...this.estruturaSuperiorOperadorField,
            size: 6,
          },
          {
            ...this.estruturaLegalField,
            size: 6,
          },
          this.estruturaGerencialField,
          {
            ...this.vinculosField,
            required: false,
          },
        ],
        params: [
          {
            fieldName: 'DTMESCOMPETENCIA',
            param: "P_DTMESCOMPETENC",
            required: true
          },
          {
            fieldName: 'NRESTRUTLEGAL',
            param: "P_NRESTRUTLEGAL"
          },
          {
            fieldName: 'NRESTRUTGEREN',
            param: "P_ESTRUTGEREN"
          },
          {
            fieldName: 'NRVINCULOM',
            param: "P_NRVINCULO"
          },
          {
            fieldName: 'DATA',
            param: "P_DIA"
          },
          {
            fieldName: 'format',
            param: "__format",
            defaultValue: 'xlsx'
          },
          {
            fieldName: 'NRESTRUTSUPERIOR',
            param: 'P_NRESTRUTSUP',
            required: !this.isEstruturaSupSelected(),
            defaultValue: '',
          },
          {
            fieldName: 'NRTIPOHIERARQ',
            param: 'P_NRTIPOHIERARQ',
            required: !this.isEstruturaSupSelected(),
            defaultValue: '',
          },
        ],
      },
      {
        name: 'Aviso Prévio de Férias',
        value: 'aviso_previo_ferias',
        defaultRow: {
          NRESTRUTLEGAL: null,
          DUASVIAS: 'N',
        },
        sendEmptyParams: true,
        onSelection: this.avisoFeriasOnSelection,
        fields: [
          this.dtCompetenciaField,
          {
            ...this.emptyField,
            size: 4,
          },
          {
            ...this.estruturaSuperiorOperadorField,
            size: 6,
          },
          {
            ...this.estruturaGerencialField,
            required: this.isEstruturaSupSelected(),
            size: 6,
          },
          {
            ...this.dtGozoIniField,
            size: 3,
          },
          {
            ...this.dtGozoFimField,
            size: 3,
          },
          {
            ...this.vinculosField,
            required: false,
          },
          {
            ...this.dtDocumentoField,
            size: 6,
          },
          this.duasViasField,
        ] as Field[],
        fieldsDP: [
          this.dtCompetenciaField,
          this.estruturaSuperiorOperadorField,
          this.estruturaLegalField,
          this.estruturaGerencialField,
          this.dtGozoIniField,
          this.dtGozoFimField,
          this.loteVinculosField,
          {
            ...this.vinculosField,
            required: false,
          },
          {
            ...this.dtDocumentoField,
            size: 6,
          },
          this.duasViasField,
        ],
        params: [
          {
            fieldName: 'DTMESCOMPETENCIA',
            param: "P_DTMESCOMPETENC",
            required: true
          },
          {
            fieldName: 'NRESTRUTLEGAL',
            param: "P_NRESTRUTURA"
          },
          {
            fieldName: 'NRESTRUTGEREN',
            param: "P_NRESTRUTGEREN"
          },
          {
            fieldName: 'NRTIPOHIERARQ',
            param: 'P_NRTIPOHIERARQ',
          },
          {
            fieldName: 'NRESTRUTSUPERIOR',
            param: 'P_NRESTRUTSUP',
          },
          {
            fieldName: 'NRVINCULOM',
            param: "P_NRVINCULOM"
          },
          {
            fieldName: 'DTINIGOZO',
            param: "P_DATAINICIAL"
          },
          {
            fieldName: 'DTFIMGOZO',
            param: "P_DATAFINAL"
          },
          {
            fieldName: 'NRLOTEVINC',
            param: "P_LISTA_LOTE_VINCULOS"
          },
          {
            fieldName: 'NRVINCULOM',
            param: "P_NRVINCULOM"
          },
          {
            fieldName: 'DUASVIAS',
            param: "P_2VIAS"
          },
          {
            fieldName: 'DTDOCUMENTO',
            param: "P_DTDOCUMENTO"
          },
        ],
      },
      {
        name: 'Solicitação de Horas Extras',
        value: TiposSolicitacao.TP_SOLI_APROVAHE,
        defaultRow: {},
        sendEmptyParams: false,
        hideGenerateAction: true,
        hideSendAction: true,
        fields: [
          this.statusField,
          this.dtInicioSolicitacaoField,
          this.dtFimSolicitacaoField,
          this.dtHorasExtrasField,
          this.horaInicioHorasExtrasField,
          this.horaFimHorasExtrasField,
          { 
            ...this.vinculosField,  
            required: false, 
          },
          this.solicitacoesField,
          this.estruturaSuperiorOperadorField,
          this.estruturaGerencialField,
        ] as Field[],
        fieldsDP: [
          this.statusField,
          this.dtInicioSolicitacaoField,
          this.dtFimSolicitacaoField,
          this.dtHorasExtrasField,
          this.horaInicioHorasExtrasField,
          this.horaFimHorasExtrasField,
          { 
            ...this.vinculosField,  
            required: false, 
          },
          this.solicitacoesField,
          this.estruturaSuperiorOperadorField,
          this.estruturaLegalField,
          this.estruturaGerencialField,
        ],
        params: [],
      },
      {
        name: 'Solicitação de Alteração de Escala de Trabalho',
        value: TiposSolicitacao.TP_SOLI_ALTERAESCALA,
        sendEmptyParams: false,
        defaultRow: {},
        hideGenerateAction: true,
        hideSendAction: true,
        onSelection: this.solicitacaoAlteEscalaOnSelection,
        fields: [
          this.statusField,
          this.dtInicioSolicitacaoField,
          this.dtFimSolicitacaoField,
          this.dtInicioEscalaField,
          this.escalaField,
          this.turnoField,
          { 
            ...this.vinculosField,  
            required: false, 
          },
          this.solicitacoesField,
          this.estruturaSuperiorOperadorField,
          this.estruturaGerencialField,
        ] as Field[],
        fieldsDP: [
          this.statusField,
          this.dtInicioSolicitacaoField,
          this.dtFimSolicitacaoField,
          this.dtInicioEscalaField,
          this.escalaField,
          this.turnoField,
          { 
            ...this.vinculosField,  
            required: false, 
          },
          this.solicitacoesField,
          this.estruturaSuperiorOperadorField,
          this.estruturaLegalField,
          this.estruturaGerencialField,
        ],
        params: [],
      },
      {
        name: 'Solicitação de Alteração Salarial',
        value: TiposSolicitacao.TP_SOLI_SALARIO,
        defaultRow: {},
        hideGenerateAction: true,
        hideSendAction: true,
        sendEmptyParams: false,
        fields: [
          this.statusField,
          this.dtInicioSolicitacaoField,
          this.dtFimSolicitacaoField,
          this.salarioField,
          this.tipoSalarioField,
          this.dtAlteracaoSalField,
          { 
            ...this.vinculosField,  
            required: false, 
          },
          this.solicitacoesField,
          this.estruturaSuperiorOperadorField,
          this.estruturaGerencialField,
        ] as Field[],
        fieldsDP: [
          this.statusField,
          this.dtInicioSolicitacaoField,
          this.dtFimSolicitacaoField,
          this.salarioField,
          this.tipoSalarioField,
          this.dtAlteracaoSalField,
          { 
            ...this.vinculosField,  
            required: false, 
          },
          this.solicitacoesField,
          this.estruturaSuperiorOperadorField,
          this.estruturaLegalField,
          this.estruturaGerencialField,
        ],
        params: [],
      },
      {
        name: 'Solicitação de Alteração de Ocupação',
        value: TiposSolicitacao.TP_SOLI_OCUPACAO,
        defaultRow: {},
        hideGenerateAction: true,
        hideSendAction: true,
        onSelection: this.solicitacaoAlteOcupaOnSelection,
        sendEmptyParams: false,
        fields: [
          this.statusField,
          this.dtInicioSolicitacaoField,
          this.dtFimSolicitacaoField,
          this.ocupacaoField,
          this.motivoAlteOcupaField,
          this.tipoOcupacaoField,
          this.dtIniOcupaField,
          { 
            ...this.vinculosField,  
            required: false, 
          },
          this.solicitacoesField,
          this.estruturaSuperiorOperadorField,
          this.estruturaGerencialField,
        ] as Field[],
        fieldsDP: [
          this.statusField,
          this.dtInicioSolicitacaoField,
          this.dtFimSolicitacaoField,
          this.ocupacaoField,
          this.motivoAlteOcupaField,
          this.tipoOcupacaoField,
          this.dtIniOcupaField,
          { 
            ...this.vinculosField,  
            required: false, 
          },
          this.solicitacoesField,
          this.estruturaSuperiorOperadorField,
          this.estruturaLegalField,
          this.estruturaGerencialField,
        ],
        params: [],
      },
      {
        name: 'Solicitação de Aumento de Quadro',
        value: TiposSolicitacao.TP_SOLI_AUMENTO_QUADRO,
        defaultRow: {},
        hideGenerateAction: true,
        hideSendAction: true,
        onSelection: this.solicitacaoAumentoQuadroOnSelection,
        sendEmptyParams: false,
        fields: [
          this.statusField,
          this.dtInicioSolicitacaoField,
          this.dtFimSolicitacaoField,
          this.nmProcessoField,
          this.templateProcessoField,
          this.tipoProcessoField,
          this.dataInicioProcessoField,
          this.dataFimProcessoField,
          this.dataPrevistaField,
          this.qntVagasProcessoField,
          this.ocupacaoField,
          this.escalaField,
          {
            ...this.salarioField,
            label: 'Salário Proposto',
          },
          {
            ...this.tipoVinculoField,
            size: 4,
            required: false,
          },
          this.vinculoEmpregaticioField,
          { 
            ...this.vinculosField,  
            required: false, 
          },
          this.solicitacoesField,
          this.estruturaSuperiorOperadorField,
          this.estruturaGerencialField,
        ] as Field[],
        fieldsDP: [
          this.statusField,
          this.dtInicioSolicitacaoField,
          this.dtFimSolicitacaoField,
          this.nmProcessoField,
          this.templateProcessoField,
          this.tipoProcessoField,
          this.dataInicioProcessoField,
          this.dataFimProcessoField,
          this.dataPrevistaField,
          this.qntVagasProcessoField,
          this.ocupacaoField,
          this.escalaField,
          {
            ...this.salarioField,
            label: 'Salário Proposto',
          },
          {
            ...this.tipoVinculoField,
            size: 4,
            required: false,
          },
          this.vinculoEmpregaticioField,
          { 
            ...this.vinculosField,  
            required: false, 
          },
          this.solicitacoesField,
          this.estruturaSuperiorOperadorField,
          this.estruturaLegalField,
          this.estruturaGerencialField,
        ],
        params: [],
      },
      {
        name: 'Solicitação de Desligamento',
        value: TiposSolicitacao.TP_SOLI_DESLIGAMENTO,
        defaultRow: {},
        hideGenerateAction: true,
        sendEmptyParams: false,
        onSelection: this.solicitacaoDesligamentoOnSelection,
        hideSendAction: true,
        fields: [
          this.statusField,
          this.dtInicioSolicitacaoField,
          this.dtFimSolicitacaoField,
          this.tipoAvisoPrevioField,
          this.tipoDemissaoField,
          this.motivoRescisaoField,
          {
            ...this.dataUltDiaTrabField,
            size: 6,
          },
          {
            ...this.dataResciProjField,
            size: 6,
          },
          this.possuiBensField,
          this.reposicaoVagaField,
          this.pessoaNaoGrataField,
          { 
            ...this.vinculosField,  
            required: false, 
          },
          this.solicitacoesField,
          this.estruturaSuperiorOperadorField,
          this.estruturaGerencialField,
        ] as Field[],
        fieldsDP: [
          this.statusField,
          this.dtInicioSolicitacaoField,
          this.dtFimSolicitacaoField,
          this.tipoAvisoPrevioField,
          this.tipoDemissaoField,
          this.motivoRescisaoField,
          {
            ...this.dataUltDiaTrabField,
            size: 6,
          },
          {
            ...this.dataResciProjField,
            size: 6,
          },
          this.possuiBensField,
          this.reposicaoVagaField,
          this.pessoaNaoGrataField,
          { 
            ...this.vinculosField,  
            required: false, 
          },
          this.solicitacoesField,
          this.estruturaSuperiorOperadorField,
          this.estruturaLegalField,
          this.estruturaGerencialField,
        ],
        params: [],
      },
      {
        name: 'Solicitação de Advertência/Suspensão',
        value: TiposSolicitacao.TP_SOLI_ADVERTENCIA,
        defaultRow: {},
        sendEmptyParams: false,
        hideGenerateAction: true,
        hideSendAction: true,
        fields: [
          this.statusField,
          this.dtInicioSolicitacaoField,
          this.dtFimSolicitacaoField,
          this.dtIniSuspensaoField,
          this.qtdeDiasSuspensaoField,
          this.dtFimSuspensaoField,
          this.situFuncSuspensaoField,
          { 
            ...this.vinculosField,  
            required: false, 
          },
          this.solicitacoesField,
          this.estruturaSuperiorOperadorField,
          this.estruturaGerencialField,
        ] as Field[],
        fieldsDP: [
          this.statusField,
          this.dtInicioSolicitacaoField,
          this.dtFimSolicitacaoField,
          this.dtIniSuspensaoField,
          this.qtdeDiasSuspensaoField,
          this.dtFimSuspensaoField,
          this.situFuncSuspensaoField,
          this.emptyField,
          { 
            ...this.vinculosField,  
            required: false, 
          },
          this.solicitacoesField,
          this.estruturaSuperiorOperadorField,
          this.estruturaLegalField,
          this.estruturaGerencialField,
        ],
        params: [],
      },
      {
        name: 'Solicitação de Auxílio Moradia',
        value: TiposSolicitacao.TP_SOLI_AUXILIOMORADIA,
        defaultRow: {},
        sendEmptyParams: false,
        hideGenerateAction: true,
        hideSendAction: true,
        fields: [
          this.statusField,
          this.dtInicioSolicitacaoField,
          this.dtFimSolicitacaoField,
          this.dtIniAuxMoradiaField,
          this.dtFimAuxMoradiaField,
          this.valorBeneficioField,
          { 
            ...this.vinculosField,  
            required: false, 
          },
          this.solicitacoesField,
          this.estruturaSuperiorOperadorField,
          this.estruturaGerencialField,
        ] as Field[],
        fieldsDP: [
          this.statusField,
          this.dtInicioSolicitacaoField,
          this.dtFimSolicitacaoField,
          this.dtIniAuxMoradiaField,
          this.dtFimAuxMoradiaField,
          this.valorBeneficioField,
          { 
            ...this.vinculosField,  
            required: false, 
          },
          this.solicitacoesField,
          this.estruturaSuperiorOperadorField,
          this.estruturaLegalField,
          this.estruturaGerencialField,
        ],
        params: [],
      },
      {
        name: 'Solicitação de Benefícios',
        value: TiposSolicitacao.TP_SOLI_BENEFICIOS,
        defaultRow: {},
        sendEmptyParams: false,
        hideGenerateAction: true,
        onSelection: this.solicitacaoBeneficioOnSelection,
        hideSendAction: true,
        fields: [
          this.statusField,
          this.dtInicioSolicitacaoField,
          this.dtFimSolicitacaoField,
          this.tipoAletaracaoBeneficioField,
          this.beneficioField,
          this.qtdeBeneficioField,
          this.dtIniBeneficioField,
          this.dtFimBeneficioField,
          { 
            ...this.vinculosField,  
            required: false, 
          },
          this.solicitacoesField,
          this.estruturaSuperiorOperadorField,
          this.estruturaGerencialField,
        ] as Field[],
        fieldsDP: [
          this.statusField,
          this.dtInicioSolicitacaoField,
          this.dtFimSolicitacaoField,
          this.tipoAletaracaoBeneficioField,
          this.beneficioField,
          this.qtdeBeneficioField,
          this.dtIniBeneficioField,
          this.dtFimBeneficioField,
          { 
            ...this.vinculosField,  
            required: false, 
          },
          this.solicitacoesField,
          this.estruturaSuperiorOperadorField,
          this.estruturaLegalField,
          this.estruturaGerencialField,
        ],
        params: [],
      },
      {
        name: 'Solicitação de Férias',
        value: TiposSolicitacao.TP_SOLI_FERIAS,
        defaultRow: {},
        sendEmptyParams: false,
        hideGenerateAction: true,
        hideSendAction: true,
        fields: [
          this.statusField,
          this.dtInicioSolicitacaoField,
          this.dtFimSolicitacaoField,
          this.qtdeDiasFeriasField,
          this.dtIniFeriasField,
          this.dtFimFeriasField,
          this.adiantamentoDecTercField,
          { 
            ...this.vinculosField,  
            required: false, 
          },
          this.solicitacoesField,
          this.estruturaSuperiorOperadorField,
          this.estruturaGerencialField,
        ] as Field[],
        fieldsDP: [
          this.statusField,
          this.dtInicioSolicitacaoField,
          this.dtFimSolicitacaoField,
          this.qtdeDiasFeriasField,
          this.dtIniFeriasField,
          this.dtFimFeriasField,
          this.adiantamentoDecTercField,
          {
            ...this.emptyField,
            size: 8,
          },
          { 
            ...this.vinculosField,  
            required: false, 
          },
          this.solicitacoesField,
          this.estruturaSuperiorOperadorField,
          this.estruturaLegalField,
          this.estruturaGerencialField,
        ],
        params: [],
      },
      {
        name: 'Solicitação de Inclusão de Dependentes',
        value: TiposSolicitacao.TP_SOLI_DEP,
        defaultRow: {},
        sendEmptyParams: false,
        hideGenerateAction: true,
        onSelection: this.solicitacaoDependentesOnSelection,
        hideSendAction: true,
        fields: [
          this.statusField,
          this.dtInicioSolicitacaoField,
          this.dtFimSolicitacaoField,
          this.tiposRelacionamentoField,
          this.dtNascimentoField,
          this.sexoField,
          { 
            ...this.vinculosField,  
            required: false, 
          },
          this.solicitacoesField,
          this.estruturaSuperiorOperadorField,
          this.estruturaGerencialField,
        ] as Field[],
        fieldsDP: [
          this.statusField,
          this.dtInicioSolicitacaoField,
          this.dtFimSolicitacaoField,
          this.tiposRelacionamentoField,
          this.dtNascimentoField,
          this.sexoField,
          { 
            ...this.vinculosField,  
            required: false, 
          },
          this.solicitacoesField,
          this.estruturaSuperiorOperadorField,
          this.estruturaLegalField,
          this.estruturaGerencialField,
        ],
        params: [],
      },
      {
        name: 'Solicitação de Movimentação, Ocupação e Salário',
        value: TiposSolicitacao.TP_SOLI_MOVIM_OCUPACAO_SALARIO,
        defaultRow: {},
        sendEmptyParams: false,
        hideGenerateAction: true,
        onSelection: this.solicitacaoMoviOcuSalOnSelection,
        hideSendAction: true,
        fields: [
          this.statusField,
          this.dtInicioSolicitacaoField,
          this.dtFimSolicitacaoField,
          this.transferenciaField,
          this.motivoTransferenciaField,
          this.ocupacaoField,
          this.motivoAlteOcupaField,
          this.tipoOcupacaoField,
          this.salarioField,
          this.tipoSalarioField,
          this.tipoAlteracaoSalarioField,
          this.dtIniMovimentacaoField,
          this.dtFimMovimentacaoField,
          this.estruturaGerencialItemField,
          { 
            ...this.vinculosField,  
            required: false, 
          },
          this.solicitacoesField,
          this.estruturaSuperiorOperadorField,
          this.estruturaGerencialField,
        ] as Field[],
        fieldsDP: [
          this.statusField,
          this.dtInicioSolicitacaoField,
          this.dtFimSolicitacaoField,
          this.transferenciaField,
          this.motivoTransferenciaField,
          this.ocupacaoField,
          this.motivoAlteOcupaField,
          this.tipoOcupacaoField,
          this.salarioField,
          this.tipoSalarioField,
          this.tipoAlteracaoSalarioField,
          this.dtIniMovimentacaoField,
          this.dtFimMovimentacaoField,
          this.estruturaGerencialItemField,
          this.estruturaLegalItemField,
          { 
            ...this.vinculosField,  
            required: false, 
          },
          this.solicitacoesField,
          this.estruturaSuperiorOperadorField,
          this.estruturaLegalField,
          this.estruturaGerencialField,
        ],
        params: [],
      },
      {
        name: 'Solicitação de Redução Salarial',
        value: TiposSolicitacao.TP_SOLI_SALARIO_ESCALA,
        defaultRow: {},
        sendEmptyParams: false,
        hideGenerateAction: true,
        onSelection: this.solicitacaoReducaoSalarialOnSelection,
        hideSendAction: true,
        fields: [
          this.statusField,
          this.dtInicioSolicitacaoField,
          this.dtFimSolicitacaoField,
          this.dtAlteracaoSalField,
          this.dtInicioEscalaField,
          this.salarioField,
          this.tipoSalarioField,
          this.tipoAlteracaoSalarioField,
          this.escalaField,
          this.turnoField,
          this.transferenciaField,
          this.ocupacaoField,
          this.motivoAlteOcupaField,
          this.tipoOcupacaoField,
          this.dtIniMovimentacaoField,
          this.dtFimMovimentacaoField,
          this.estruturaGerencialItemField,
          { 
            ...this.vinculosField,  
            required: false, 
          },
          this.solicitacoesField,
          this.estruturaSuperiorOperadorField,
          this.estruturaGerencialField,
        ] as Field[],
        fieldsDP: [
          this.statusField,
          this.dtInicioSolicitacaoField,
          this.dtFimSolicitacaoField,
          this.dtAlteracaoSalField,
          this.salarioField,
          this.tipoSalarioField,
          this.tipoAlteracaoSalarioField,
          this.dtInicioEscalaField,
          this.escalaField,
          this.turnoField,
          this.transferenciaField,
          this.ocupacaoField,
          this.motivoAlteOcupaField,
          this.tipoOcupacaoField,
          this.dtIniMovimentacaoField,
          this.dtFimMovimentacaoField,
          this.estruturaGerencialItemField,
          this.estruturaLegalItemField,
          { 
            ...this.vinculosField,  
            required: false, 
          },
          this.solicitacoesField,
          this.estruturaSuperiorOperadorField,
          this.estruturaLegalField,
          this.estruturaGerencialField,
        ],
        params: [],
      },
      {
        name: 'Solicitação de Reembolso',
        value: TiposSolicitacao.TP_SOLI_REEMBOLSO,
        defaultRow: {},
        sendEmptyParams: false,
        hideGenerateAction: true,
        hideSendAction: true,
        fields: [
          this.statusField,
          this.dtInicioSolicitacaoField,
          this.dtFimSolicitacaoField,
          this.valorReembolsoField,
          {
            ...this.dtCompetenciaField,
            label: 'Mês de Referência',
            required: false,
          },
          { 
            ...this.vinculosField,  
            required: false, 
          },
          this.solicitacoesField,
          this.estruturaSuperiorOperadorField,
          this.estruturaGerencialField,
        ] as Field[],
        fieldsDP: [
          this.statusField,
          this.dtInicioSolicitacaoField,
          this.dtFimSolicitacaoField,
          this.valorReembolsoField,
          {
            ...this.dtCompetenciaField,
            label: 'Mês de Referência',
            required: false,
          },
          { 
            ...this.vinculosField,  
            required: false, 
          },
          this.solicitacoesField,
          this.estruturaSuperiorOperadorField,
          this.estruturaLegalField,
          this.estruturaGerencialField,
        ],
        params: [],
      },
      {
        name: 'Solicitação de Remanejamento/Transferência - Gerencial',
        value: TiposSolicitacao.TP_SOLI_MOVIM_GERENCIAL,
        defaultRow: {},
        sendEmptyParams: false,
        hideGenerateAction: true,
        onSelection: this.solicitacaoTransfGerenOnSelection,
        hideSendAction: true,
        fields: [
          this.statusField,
          this.dtInicioSolicitacaoField,
          this.dtFimSolicitacaoField,
          this.dtIniMovimentacaoField,
          this.motivoAlteOcupaField,
          this.estruturaGerencialItemField,
          this.dtInicioEscalaField,
          this.escalaField,
          this.turnoField,
          { 
            ...this.vinculosField,  
            required: false, 
          },
          this.solicitacoesField,
          this.estruturaSuperiorOperadorField,
          this.estruturaGerencialField,
        ] as Field[],
        fieldsDP: [
          this.statusField,
          this.dtInicioSolicitacaoField,
          this.dtFimSolicitacaoField,
          this.dtIniMovimentacaoField,
          this.motivoAlteOcupaField,
          this.estruturaGerencialItemField,
          this.dtInicioEscalaField,
          this.escalaField,
          this.turnoField,
          { 
            ...this.vinculosField,  
            required: false, 
          },
          this.solicitacoesField,
          this.estruturaSuperiorOperadorField,
          this.estruturaLegalField,
          this.estruturaGerencialField,
        ],
        params: [],
      },
      {
        name: 'Solicitação de Remanejamento/Transferência - Legal',
        value: TiposSolicitacao.TP_SOLI_MOVIM_LEGAL,
        defaultRow: {},
        sendEmptyParams: false,
        hideGenerateAction: true,
        onSelection: this.solicitacaoTransfLegalOnSelection,
        hideSendAction: true,
        fields: [
          this.statusField,
          this.dtInicioSolicitacaoField,
          this.dtFimSolicitacaoField,
          this.dtIniMovimentacaoField,
          this.motivoAlteOcupaField,
          this.estruturaLegalItemField,
          this.estruturaGerencialItemField,
          this.dtInicioEscalaField,
          this.escalaField,
          this.turnoField,
          { 
            ...this.vinculosField,  
            required: false, 
          },
          this.solicitacoesField,
          this.estruturaSuperiorOperadorField,
          this.estruturaGerencialField,
        ] as Field[],
        fieldsDP: [
          this.statusField,
          this.dtInicioSolicitacaoField,
          this.dtFimSolicitacaoField,
          this.dtIniMovimentacaoField,
          this.motivoAlteOcupaField,
          this.estruturaLegalItemField,
          this.estruturaGerencialItemField,
          this.dtInicioEscalaField,
          this.escalaField,
          this.turnoField,
          this.emptyField,
          { 
            ...this.vinculosField,  
            required: false, 
          },
          this.solicitacoesField,
          this.estruturaSuperiorOperadorField,
          this.estruturaLegalField,
          this.estruturaGerencialField,
        ],
        params: [],
      },
      {
        name: 'Solicitação de Substituição',
        value: TiposSolicitacao.TP_SOLI_SUBSTITUICAO,
        defaultRow: {},
        sendEmptyParams: false,
        hideGenerateAction: true,
        onSelection: this.solicitacaoSubstituicaoOnSelection,
        hideSendAction: true,
        fields: [
          this.statusField,
          this.dtInicioSolicitacaoField,
          this.dtFimSolicitacaoField,
          this.dtIniMovimentacaoField,
          this.motivoAlteOcupaField,
          this.estruturaLegalItemField,
          this.estruturaGerencialItemField,
          this.dtInicioEscalaField,
          this.escalaField,
          this.turnoField,
          { 
            ...this.vinculosField,  
            required: false, 
          },
          this.solicitacoesField,
          this.estruturaSuperiorOperadorField,
          this.estruturaGerencialField,
        ] as Field[],
        fieldsDP: [
          this.statusField,
          this.dtInicioSolicitacaoField,
          this.dtFimSolicitacaoField,
          this.dtIniMovimentacaoField,
          this.motivoAlteOcupaField,
          this.estruturaLegalItemField,
          this.estruturaGerencialItemField,
          this.dtInicioEscalaField,
          this.escalaField,
          this.turnoField,
          this.emptyField,
          { 
            ...this.vinculosField,  
            required: false, 
          },
          this.solicitacoesField,
          this.estruturaSuperiorOperadorField,
          this.estruturaLegalField,
          this.estruturaGerencialField,
        ],
        params: [],
      },
      {
        name: 'Solicitação de Treinamento',
        value: TiposSolicitacao.TP_SOLI_TREINAMENTO,
        defaultRow: {},
        sendEmptyParams: false,
        hideGenerateAction: true,
        onSelection: this.solicitacaoTreinamentoOnSelection,
        hideSendAction: true,
        fields: [
          this.statusField,
          this.dtInicioSolicitacaoField,
          this.dtFimSolicitacaoField,
          this.treinamentoInternoField,
          this.nomeTreinamentoField,
          this.cursoTreinamentoField,
          this.perfilAcessoField,
          this.metodoTreinamentoField,
          this.perfilExecTreinamentoField,
          this.dtIniTreinamentoField,
          this.dtFimTreinamentoField,
          { 
            ...this.vinculosField,  
            required: false, 
          },
          this.solicitacoesField,
          this.estruturaSuperiorOperadorField,
          this.estruturaGerencialField,
        ] as Field[],
        fieldsDP: [
          this.statusField,
          this.dtInicioSolicitacaoField,
          this.dtFimSolicitacaoField,
          this.treinamentoInternoField,
          this.nomeTreinamentoField,
          this.cursoTreinamentoField,
          this.perfilAcessoField,
          this.metodoTreinamentoField,
          this.perfilExecTreinamentoField,
          this.dtIniTreinamentoField,
          this.dtFimTreinamentoField,
          { 
            ...this.vinculosField,  
            required: false, 
          },
          this.solicitacoesField,
          this.estruturaSuperiorOperadorField,
          this.estruturaLegalField,
          this.estruturaGerencialField,
        ],
        params: [],
      },
      {
        name: 'Solicitação de Vale Combustível',
        value: TiposSolicitacao.TP_SOLI_VCOMBUST,
        defaultRow: {},
        sendEmptyParams: false,
        hideGenerateAction: true,
        onSelection: this.solicitacaoVCOnSelection,
        hideSendAction: true,
        fields: [
          this.statusField,
          this.dtInicioSolicitacaoField,
          this.dtFimSolicitacaoField,
          this.tipoAlteracaoField,
          this.tipoValeCombustivelField,
          this.qntCombustivelField,
          this.tipoBeneficioCombustivelField,
          this.dataIniCombustivelField,
          this.dataFimCombustivelField,
          { 
            ...this.vinculosField,  
            required: false, 
          },
          this.solicitacoesField,
          this.estruturaSuperiorOperadorField,
          this.estruturaGerencialField,
        ] as Field[],
        fieldsDP: [
          this.statusField,
          this.dtInicioSolicitacaoField,
          this.dtFimSolicitacaoField,
          this.tipoAlteracaoField,
          this.tipoValeCombustivelField,
          this.qntCombustivelField,
          this.tipoBeneficioCombustivelField,
          this.dataIniCombustivelField,
          this.dataFimCombustivelField,
          { 
            ...this.vinculosField,  
            required: false, 
          },
          this.solicitacoesField,
          this.estruturaSuperiorOperadorField,
          this.estruturaLegalField,
          this.estruturaGerencialField,
        ],
        params: [],
      },
      {
        name: 'Solicitação de Vale Manutenção',
        value: TiposSolicitacao.TP_SOLI_VMANUTENCAO,
        defaultRow: {},
        sendEmptyParams: false,
        hideGenerateAction: true,
        onSelection: this.solicitacaoValeManutencaoOnSelection,
        hideSendAction: true,
        fields: [
          this.statusField,
          this.dtInicioSolicitacaoField,
          this.dtFimSolicitacaoField,
          this.tipoPeriodoBeneficioField,
          this.tipoBeneficioManutencaoField,
          this.qntBeneficioManutencaoField,
          this.dtIniBeneficioField,
          this.dtFimBeneficioField,
          { 
            ...this.vinculosField,  
            required: false, 
          },
          this.solicitacoesField,
          this.estruturaSuperiorOperadorField,
          this.estruturaGerencialField,
        ] as Field[],
        fieldsDP: [
          this.statusField,
          this.dtInicioSolicitacaoField,
          this.dtFimSolicitacaoField,
          this.tipoPeriodoBeneficioField,
          this.tipoBeneficioManutencaoField,
          this.qntBeneficioManutencaoField,
          this.dtIniBeneficioField,
          this.dtFimBeneficioField,
          { 
            ...this.vinculosField,  
            required: false, 
          },
          this.solicitacoesField,
          this.estruturaSuperiorOperadorField,
          this.estruturaLegalField,
          this.estruturaGerencialField,
        ],
        params: [],
      },
      {
        name: 'Solicitação de Vale Transporte',
        value: TiposSolicitacao.TP_SOLI_VTRANS,
        defaultRow: {},
        sendEmptyParams: false,
        hideGenerateAction: true,
        onSelection: this.solicitacaoValeTransporteOnSelection,
        hideSendAction: true,
        fields: [
          this.statusField,
          this.dtInicioSolicitacaoField,
          this.dtFimSolicitacaoField,
          this.tipoValeTransporteField,
          this.dtAlteValeTransporteField,
          this.linhaTransporteField,
          this.tipoLinhaTransporteField,
          this.vrTarifaTransporteField,
          this.qntdTransporteField,
          { 
            ...this.vinculosField,  
            required: false, 
          },
          this.solicitacoesField,
          this.estruturaSuperiorOperadorField,
          this.estruturaGerencialField,
        ] as Field[],
        fieldsDP: [
          this.statusField,
          this.dtInicioSolicitacaoField,
          this.dtFimSolicitacaoField,
          this.tipoAlteracaoField,
          this.dtAlteValeTransporteField,
          this.linhaTransporteField,
          this.tipoLinhaTransporteField,
          this.vrTarifaTransporteField,
          this.qntdTransporteField,
          { 
            ...this.vinculosField,  
            required: false, 
          },
          this.solicitacoesField,
          this.estruturaSuperiorOperadorField,
          this.estruturaLegalField,
          this.estruturaGerencialField,
        ],
        params: [],
      },
      {
        name: 'Solicitação de Anotações do Vínculo - Advertência e Suspensão',
        value: TiposSolicitacao.TP_SOLI_ADVERTENCIA_ANOT_VINC,
        sendEmptyParams: false,
        defaultRow: {},
        hideGenerateAction: true,
        hideSendAction: true,
        fields: [
          this.statusField,
          this.dtInicioSolicitacaoField,
          this.dtFimSolicitacaoField,
          { 
            ...this.vinculosField,  
            required: false, 
          },
          this.solicitacoesField,
          this.estruturaSuperiorOperadorField,
          this.estruturaGerencialField,
        ] as Field[],
        fieldsDP: [
          this.statusField,
          this.dtInicioSolicitacaoField,
          this.dtFimSolicitacaoField,
          { 
            ...this.vinculosField,  
            required: false, 
          },
          this.solicitacoesField,
          this.estruturaSuperiorOperadorField,
          this.estruturaLegalField,
          this.estruturaGerencialField,
        ],
        params: [],
      },
      {
        name: 'Demonstrativo de Benefícios',
        value: 'demonstrativo_beneficios_modelo2',
        defaultRow: {},
        onSelection: this.demonstrativoBeneficioOnSelection,
        sendEmptyParams: true,
        fields: [
          this.dtCompetenciaField,
          this.vinculosField,
          this.solicitacoesField,
          {
            ...this.estruturaSuperiorOperadorField,
            size: 6,
          },
          {
            ...this.estruturaGerencialField,
            size: 6,
          },
          {
            ...this.beneficioField,
            required:true,
            size:6
          },
          this.tipoBeneficioField,
          this.dataInicioPagamentoField,
          this.dataFimPagamentoField,
          {
            ...this.dtInicioField,
            required:false,
            size:6
          },
          {
            ...this.dtFimField,
            required:false,
            size:6
          },
          this.dataPeriodoInicialField,
          this.dataPeriodoFinalField,
          this.paginarPorEstruturasField,
          this.tituloRelatorioField,
        
        ] as Field[],
        fieldsDP:[
          this.dtCompetenciaField,
          this.vinculosField,
          this.solicitacoesField,
          {
            ...this.estruturaSuperiorOperadorField,
            size: 6,
          },
          {
            ...this.estruturaLegalField,
            required: false,
            size: 6,
          },
          this.estruturaGerencialField,
          {
            ...this.beneficioField,
            required:true,
            size:6
          },
          this.tipoBeneficioField,
          this.dataInicioPagamentoField,
          this.dataFimPagamentoField,
          {
            ...this.dtInicioField,
            required:false,
            size:6
          },
          {
            ...this.dtFimField,
            required:false,
            size:6
          },
          this.dataPeriodoInicialField,
          this.dataPeriodoFinalField,
          this.paginarPorEstruturasField,
          this.tituloRelatorioField,
        ],
        params: [
          {
            fieldName: 'NRVINCULOM',
            param: 'P_NRVINCULO',
            defaultValue:'',
          },
          {
            fieldName: 'DTMESCOMPETENCIA',
            param: 'P_DTMESCOMPETENC',
            required: true,
          },
        
          {
            fieldName: 'NRESTRUTLEGAL',
            param: 'P_NRESTRUTLEGAL',
          },
          {
            fieldName: 'NRESTRUTGEREN',
            param: 'P_NRESTRUTGEREN',
          },
          {
            fieldName: 'NRESTRUTSUPERIOR',
            param: 'P_NRESTRUTSUP',
            defaultValue: '',
          },
          {
            fieldName: 'NRTIPOHIERARQ',
            param: 'P_NRTIPOHIERARQORG',
            defaultValue: '',
          },
          {
            fieldName: 'DTINICIOPAG',
            param: 'P_DTINICIOPAG',
          },
          {
            fieldName: 'DTFIMPAG',
            param: 'P_DTFIMPAG',
          },
          {
            fieldName: 'DTINICIO',
            param: 'P_DTINICIO',
          },
          {
            fieldName: 'DTFIM',
            param: 'P_DTFINAL',
          },
          {
            fieldName: 'NRBENEFICIOM',
            param: 'P_NRBENEFICIOM',
            required:true,
          },
          {
            fieldName: 'NRTPBENEFICIO',
            param: 'P_TPBENEFICIO',
          },
          {
            fieldName: 'TITULORELATORIO',
            param: 'P_TITULORELATORIO',
          },
          {
            fieldName: 'DTPERIODOINICIAL',
            param: 'P_PERIODOINICIAL',
          },
          {
            fieldName: 'DTPERIODOFINAL',
            param: 'P_PERIODOFINAL',
          },
          {
            fieldName: 'PAGINARPORESTRUTURAS',
            param: 'P_PAGINARPORESTRUTURAS',
            defaultValue:'N',
          },
          {
            fieldName: 'NROCORRECAL',
            param: 'P_OCORRECAL',
            required: true,
            defaultValue: 1,
          },
        ],
      },
      ...this.injectedReportsObjects,
    ] as IReportType[];
  }

  private get visibleReports(): any[] {
    const reports = this.reports.filter((report) => {
      return this.canViewReports || !report.restricted || this.user.dp;
    });

    return reports;
  }

  private get selectReportField(): Field {
    return {
      name: 'reportName',
      label: 'Relatório',
      type: 'autocomplete',
      size: Object.values(TiposSolicitacao).includes(this.formRow.reportName) ? 6 : 4,
      required: true,
      descriptionField: 'name',
      valueField: 'value',
      items: this.visibleReports,
      onInput: this.reportFieldOnInput,
    };
  }

  private get currentReportHasEstrutLegalField(): boolean {
    const isEstruturaLegalVisible = !Util.isEmptyOrBlank(
      this.formFields.find(e => e.name == this.estruturaLegalField.name)
    );
    return isEstruturaLegalVisible;
  }

  private get currentReportHasEstrutGerenField(): boolean {
    const isEstruturaLegalVisible = !Util.isEmptyOrBlank(
      this.formFields.find(e => e.name == this.estruturaGerencialField.name)
    );
    return isEstruturaLegalVisible;
  }
  // #endregion

  // #region [ LIFECYCLE ]
  private created() {
    (window as any).relatorio = this;

    this.changeCurrentView(this.viewName);
    this.defaultFilters.NRPERIODOAPURACAO = this.periodoDemonstrativoAtual.NRPERIODOAPURACAO;
    this.defaultFilters.NRORG = this.user.nrorg;
    this.defaultRow.NRPERIODOAPURACAO = this.periodoDemonstrativoAtual.NRPERIODOAPURACAO;

    this.setContentHeight();
    this.loadCanViewReports();
  }

  private mounted() {
    this.formRow = Util.deepCopy(this.defaultRow);

    this.getVinculosByEstruturaField();

    this.callOnSelectionMethod();
  }
  // #endregion

  // #region [ METHODS ]
  private validate(): boolean {
    const isValid = (this.$refs.form as any).validate(true);

    return isValid;
  }
// criar nova request
  private async generateReport() {
    if (!this.validate()) {
      return false;
    }

    const canProceed = await this.callBeforeGenerationMethod();

    if (!canProceed) {
      return;
    }

    const route = 'generateBirtReport';

    const nrOrg = this.user.nrorg;
    const cdOperador = this.user.id;
    let preparedRow = this.getParamsName(this.formRow.reportName);

    if(this.formRow.COMASSINATURADIGITAL == 'S') {
      preparedRow['P_GESTOR'] = cdOperador;
    }

    if(this.formRow.reportName == 'demonstrativo_beneficios_modelo2' && !this.user.dp) {
      preparedRow.P_NRESTRUTLEGAL = null;
    }

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
      CDOPERADOR: cdOperador,
      ...preparedRow,
    };

    this.loading = true;

    try {
      const response = await HttpRequest.get(route, params, false, null, false);

      if (response.data.messages) {
        const message: string = response.data.messages[0].message;
        SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ALERT);
      } else {
        this.reportLink = response.data.dataset.data.link;

        if(this.formRow.COMASSINATURADIGITAL === 'S') {
          this.saveAssinatura();
        }

        const file = await RelatorioController.downloadReport(this.reportLink);
        const { base64, type } = file;

        this.base64 = base64;
        this.type = type;
      }
    } catch (err) {
      const errorMessage = 'Não foi possível gerar o relatório';
      SnackbarUtils.showMessage(errorMessage, SnackbarUtils.TYPE_ERROR);

      throw err;
    } finally {
      this.loading = false;
    }

    return true;
  }

  private async openReportLink() {
    if (this.reportLink === '') {
      const generated = await this.generateReport();

      if (!generated) {
        return;
      }
    }

    window.open(this.reportLink, '_blank');
  }

  private async showReportOnScreen() {
    this.reportLink = '';
    this.showReport = false;

    await this.generateReport();

    this.showReport = true;
  }

  private async downloadReport() {
    if (!this.reportLink) {
      const generated = await this.generateReport();

      if (!generated) {
        return;
      }
    }

    if(OfflineController.isMobile()) {
      try {
        await CordovaController.checkStorageAccessMobile();
      } catch (error) {
        const message = 'Permissões de armazenamento são necessárias para baixar o relatório. Por favor, revise as permissões e tente novamente.';
        SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);
        return;
      }
    }

    this.loading = true;

    try {
      const fileName = this.formRow.reportName;

      await FileUtils.downloadBase64File(fileName, this.base64, this.type);

      const message = OfflineController.isMobile()
      ? 'Relatório baixado com sucesso na pasta de Downloads!'
      : 'Relatório baixado com sucesso!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_SUCCESS);
    } catch (err) {
      const errorMessage = 'Não foi possível baixar o relatório.';
      SnackbarUtils.showMessage(errorMessage, SnackbarUtils.TYPE_ERROR);

      throw err;
    } finally {
      this.loading = false;
    }
  }

  private async generateSolicitacaoEspelhoReport(reportType: string) {
    if (!this.validate() || !this.validateDateSolicitacao()) {
      return;
    }

    const formRowCopy = Util.deepCopy(this.formRow);
    formRowCopy.NRESTRUTLEGAL = this.user.dp ? formRowCopy.NRESTRUTLEGAL : null;

    const nrTipoSolicitacao = this.selectedReport.value as TiposSolicitacao;
    const { reportName, DTMESCOMPETENCIA, __is_valid, NRTIPOESTRUTURA, NMVINCULOM, ...formRow } = formRowCopy;
    const filters = formRow;

    const { fileName, base64, type } = await RelatorioController.generateSolicitacaoEspelhoReport(reportType, filters, nrTipoSolicitacao);

    this.loading = true;

    try {
      await FileUtils.downloadBase64File(fileName, base64, type);

      const message = 'Relatório baixado com sucesso!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_SUCCESS);
    } catch (err) {
      const errorMessage = 'Não foi possível baixar o relatório.';
      SnackbarUtils.showMessage(errorMessage, SnackbarUtils.TYPE_ERROR);

      throw err;
    } finally {
      this.loading = false;
    }

  }

  private validateDateSolicitacao() {
    const inicio: string = this.formRow.DTINICIOSOLICITACAO;
    const fim: string = this.formRow.DTFIMSOLICITACAO

    if (Util.isEmptyOrBlank(inicio) || Util.isEmptyOrBlank(fim)) {
      return true;
    }

    const dtInicio = parse(inicio, 'dd/MM/yyyy', new Date());
    const dtFim = parse(fim, 'dd/MM/yyyy', new Date());
  
    if(isBefore(dtFim, dtInicio)) {
      const message = 'A data de fim deve ser superior à data de início!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      return false;
    }

    return true;
  }

  private async saveAssinatura() {
    const nrOrg = this.user.nrorg;
    const cdOperador = this.user.id;
    this.loading = true;

    const reportValue = this.formRow.reportName;
    const report = this.getReport(reportValue);
    const dsReport = report.name;
    const nmCategDocumento = report.value;

    const nmVinculo: string = this.formRow.NMVINCULOM;
    const dtCompetencia : string = this.formRow.DTMESCOMPETENCIA;
    const nrPeriodo: string = this.formRow.NRPERIODOAPURACAO;

    const nmDocumento = `${dsReport} - ${dtCompetencia} - ${nrPeriodo} - ${nmVinculo}`;

    try{
      const response = await HttpRequest.post('saveDocumentoAssinatura', {
        requestType: 'Row',
        NRORG: nrOrg,
        row: {
            FILE: this.reportLink,
            CDOPERADOR: cdOperador,
            NRVINCULOM: this.formRow.NRVINCULOM,
            NMANEXO: 'Relatório Assinatura Digital',
            NMDOCUMENTO: nmDocumento,
            NMCATEGDOCUMENTO: nmCategDocumento
          },
      }, true);
      
    } catch (err) {
      const errorMessage = 'Não foi possível salvar o relatório para assinatura';
      SnackbarUtils.showMessage(errorMessage, SnackbarUtils.TYPE_ERROR);

      throw err;
    } finally {
      this.loading = false;
    }
  }

  private formOnInput() {
    this.reportLink = '';
    this.showReport = false;
  }
  
  private async getVinculosByEstruturaField() {
    const nrEstruturaGerencial = this.formRow.NRESTRUTGEREN;
    const nrEstruturaLegal = this.formRow.NRESTRUTLEGAL;
  
    if (nrEstruturaGerencial) {
      await this.updateVinculos(nrEstruturaGerencial);
      return;
    }
  
    if (nrEstruturaLegal && !nrEstruturaGerencial && this.user.dp && this.currentReportHasEstrutLegalField) {
      await this.updateVinculos(nrEstruturaLegal);
      return;
    }
  
    this.updateVinculos();
  }
  
  private async updateVinculos(nrEstrutura?: string) {
    if (this.prevNrEstrutura !== nrEstrutura || !this.prevNrEstrutura) {
      const dtCompetencia: string = this.formRow.DTMESCOMPETENCIA;
      const vinculos = await CommonRequests.getVinculosDoGestor(true, nrEstrutura, dtCompetencia);
      this.fieldsData.vinculos = vinculos;
      this.prevNrEstrutura = nrEstrutura;

      const vinculoEmpty = !vinculos || (Array.isArray(vinculos) && !vinculos.length);

      if(vinculoEmpty) {
        const { NRVINCULOM, ...formRow } = this.formRow;
        this.formRow = Util.deepCopy(formRow);
      }

      return;
    }
    this.prevNrEstrutura = undefined;
  }  

  private getParamsName(reportName: string) {
    const nrOrg = this.user.nrorg;
    const newParams: any = {};

    const params = this.selectedReport.params;

    newParams.reportName = reportName;
    newParams.P_NRORG = nrOrg;

    params.forEach((field: any) => {
      if (!Util.isEmptyOrBlank(this.formRow[field.fieldName])) {
        newParams[field.param] = this.formRow[field.fieldName];
      } else if (field.defaultValue !== undefined) {
        newParams[field.param] = field.defaultValue;
      }
    });

    return newParams;
  }

  private getReport(
    reportValue: string,
  ) {
    const report = this.reports.find((rpt) => {
      return rpt.value === reportValue;
    });

    return report;
  }

  private reportFieldOnInput() {
    this.callOnSelectionMethod();

    this.reportFieldSolicitacaoOnInput();
  }

  private callOnSelectionMethod() {
    if (!this.selectedReport) {
      return;
    }

    const reportDefaultRow = this.selectedReport.defaultRow || {};

    const newRow = {
      ...this.defaultRow,
      ...reportDefaultRow,
      reportName: this.selectedReport.value,
    };

    this.formRow = newRow;

    if (this.selectedReport && this.selectedReport.onSelection) {
      this.selectedReport.onSelection();
    }
  }

  private async reportFieldSolicitacaoOnInput() {
    if(!this.isReportSolicitacao) {
      return;
    }

    await this.loadEstruturasSuperioresOperador();
    this.loadSolicitacoes();
    this.preencheEstruturaSolicitacaoReport();
  }
  
  
  // Preenche a estrutura gerencial ou superior com a estrutura atual do usuário
  private preencheEstruturaSolicitacaoReport() {
    if(this.user.dp || !this.isReportSolicitacao) return;

    try {
      if(this.estruturaGerencialAtual.NRTIPOESTRUTURA == this.user.nrtpestrutgeren) {
        this.formRow.NRESTRUTGEREN = this.estruturaGerencialAtual.NRESTRUTURAM;
        this.formRow.NRESTRUTSUPERIOR = null;
        return;
      }
  
      this.formRow.NRESTRUTSUPERIOR = this.estruturaGerencialAtual.NRESTRUTURAM;
      this.formRow.NRTIPOESTRUTURA = this.estruturaGerencialAtual.NRTIPOESTRUTURA;
      this.formRow.NRESTRUTGEREN = null;

      this.estrutSuperiorOnInput();
    } catch (error) {}
    
  }
  

  private async callBeforeGenerationMethod() {
    if (this.selectedReport.beforeGeneration) {
      const preceed = await this.selectedReport.beforeGeneration();

      if (preceed === false) {
        return false;
      }
    }

    return true;
  }

  public informeRendimentosOnSelection() {
    const estruturaAtualIsGerencial = this.estruturaGerencialAtual ?
      this.estruturaGerencialAtual.IDTIPOESTRUTURA === 'GERENCIAL' :
      false;

    if (!this.user.dp && estruturaAtualIsGerencial) {
      this.formRow.NRESTRUTGEREN = this.estruturaGerencialAtual.NRESTRUTURAM;
    }

    this.loadEstruturasGerenciais();
    this.loadEstruturasLegais();
  }

  public async loadEstruturasLegais() {
    try {
      const estruturas = await NovaSolicitacaoController.getEstruturas('LEGAL');
      this.fieldsData.estruturasLegais = estruturas;
    } catch (err) {
      const message = 'Não foi possível carregar as estruturas legais!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public async loadEstruturasGerenciais() {
    let estruturas = [];

    if (this.user.dp) {
      try {
        estruturas = await NovaSolicitacaoController.getEstruturas('GERENCIAL');
      } catch {
        const message = 'Não foi possível carregar as estruturas gerenciais!';
        SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);
      }
    } else {
      estruturas = this.estruturasGerenciaisStore.filter((estrutura) => {
        const isGerencial = estrutura.IDTIPOESTRUTURA === 'GERENCIAL';
        return isGerencial;
      });
    }

    this.fieldsData.estruturasGerenciais = estruturas;
  }

  private async loadVinculos() {
    const dtCompetencia: string = this.formRow.DTMESCOMPETENCIA;

    if (!dtCompetencia) {
      return;
    }

    try {
      this.vinculos = await CommonRequests.getVinculosDoGestor(true, '', dtCompetencia);
      this.fieldsData.vinculos = this.vinculos;
    } catch (err) {
      const message = 'Não foi possível carregar os vínculos!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  private async loadSolicitacoes() {
    if(!this.isReportSolicitacao) {
      return;
    }

    const NRTIPOSOLICITACAO = this.selectedReport.value as TiposSolicitacao;
    const NRESTRUTGEREN = this.formRow.NRESTRUTGEREN;
    const NRESTRUTLEGAL = this.formRow.NRESTRUTLEGAL;
    const NRVINCULOM = this.formRow.NRVINCULOM;

    if(!NRTIPOSOLICITACAO) return;

    const payload = {
      NRTIPOSOLICITACAO,
      NRESTRUTLEGAL,
      NRESTRUTGEREN,
      NRVINCULOM
    }

    try {

      const solicitacoes = await SolicitacaoController.getSolicitacoesSelect(payload);
      this.fieldsData.solicitacoes = solicitacoes;

      const solicitacoesEmpty = !solicitacoes || (Array.isArray(solicitacoes) && !solicitacoes.length);

      if(solicitacoesEmpty) {
        const { NRSOLICITACAO, ...formRow } = this.formRow;
        this.formRow = Util.deepCopy(formRow); 
      }

    } catch (err) {
      const message = 'Não foi possível carregar as solicitações!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  private solicitacaoAlteEscalaOnSelection() {
    this.loadEscala();
  }

  private solicitacaoAlteOcupaOnSelection() {
    this.loadOcupacoes();
    this.loadMotivos();
  }

  private solicitacaoAumentoQuadroOnSelection() {
    this.loadTemplateProcesso();
    this.loadTipoProcesso();
    this.loadEscala();
    this.loadOcupacoes();
    this.loadTiposVinculo();
    this.loadVinculosEmpregaticios();
  }

  private solicitacaoDesligamentoOnSelection() {
    this.loadTiposDemissao();
    this.loadMotivosRescisao();
    this.loadTiposAviso();
  }

  private solicitacaoBeneficioOnSelection() {
    this.loadBeneficios();
  }

  private solicitacaoDependentesOnSelection() {
    this.loadTiposRelacionamento();
  }

  private solicitacaoMoviOcuSalOnSelection() {
    this.loadTransferencias();
    this.loadMotivosTransferencia();
    this.loadOcupacoes();
    this.loadMotivos();
    this.loadTipoAlteraSal();
  }

  private solicitacaoReducaoSalarialOnSelection() {
    this.loadTransferencias();
    this.loadMotivosTransferencia();
    this.loadOcupacoes();
    this.loadMotivos();
    this.loadTipoAlteraSal();
    this.loadEscala();
  }

  private solicitacaoTransfGerenOnSelection() {
    this.loadMotivos();
    this.loadEscala();
  }

  private solicitacaoTransfLegalOnSelection() {
    this.loadMotivos();
    this.loadEscala();
  }

  private solicitacaoSubstituicaoOnSelection() {
    this.loadMotivos();
    this.loadEscala();
  }

  private solicitacaoTreinamentoOnSelection() {
    this.loadCursos();
    this.loadPerfisAcesso();
    this.loadMetodos();
  }

  private solicitacaoVCOnSelection() {
    this.loadBeneficiosVC();
  }

  private solicitacaoValeManutencaoOnSelection() {
    this.loadBeneficiosVMautencao();
  }

  private solicitacaoValeTransporteOnSelection() {
    this.loadLinhas();
    this.loadTiposLinha();
  }

  private demonstrativoBeneficioOnSelection() {
    this.loadTipoBeneficios();
    this.loadBeneficios();
    this.loadEstruturasSuperioresTipoHierarquiaInfo();
  }

  private loadDemonstrativoPontoOnSelection() {
    this.loadEstruturas();
    this.loadTiposVinculo();
  }

  private loadDemonstrativoPontoAnaliticoOnSelection() {
    this.loadEstruturasSuperioresTipoHierarquiaInfo();
    this.loadTiposVinculo();
  }

  private async loadEscala() {
    try {
      this.fieldsData.escalas = await NovaSolicitacaoController.getEscalasTrab();
    } catch {
      const message = 'Não foi possível carregar as escalas de trabalho!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);
    }
  }
  
  private async loadTurno() {
    let turnos = [];

    if(Util.isEmptyOrBlank(this.formRow.NRESCALATRABM)) {
      this.fieldsData.turnos = [];
      this.formRow.NRTURNO = null;
      return;
    }

    try {
      turnos = await NovaSolicitacaoController.getTurnos(this.formRow.NRESCALATRABM);

      if(turnos.length == 1) {
        this.formRow.NRTURNO = turnos[0].NRTURNO;
      }
    } catch {
      const message = 'Não foi possível carregar os turnos!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);
    }

    this.fieldsData.turnos = turnos;
  }

  private async loadOcupacoes() {
    try {
      this.fieldsData.ocupacoes = await NovaSolicitacaoController.getOcupacoes();
    } catch {
      const message = 'Não foi possível carregar as ocupações!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);
    }
  }

  private async loadMotivos() {
    try {
      this.fieldsData.motivosOcupa = await NovaSolicitacaoController.getMotivosOcupa();
    } catch {
      const message = 'Não foi possível carregar as ocupações!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);
    }
  }

  private async loadTemplateProcesso() {
    try {
      this.fieldsData.templates = await NovaSolicitacaoController.getTemplate();
    } catch {
      const message = 'Não foi possível carregar os templates de processo!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);
    }
  }

  private async loadTipoProcesso() {
    try {
      this.fieldsData.tiposProcesso = await NovaSolicitacaoController.getTipoprocessos();
    } catch {
      const message = 'Não foi possível carregar os tipos de processo!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);
    }
  }

  private informeRendimentosBeforeGeneration(): boolean {
    if (this.user.dp) {
      return true;
    }

    const vinculoIsSelected = !Util.isEmptyOrBlank(this.formRow.NRVINCULOM);
    const estrutGerenIsSelected = !Util.isEmptyOrBlank(this.formRow.NRESTRUTGEREN);
    const estrutSuperIsSelected = !Util.isEmptyOrBlank(this.formRow.NRESTRUTSUPERIOR);

    const vinculoOrEstrutIsSelected = vinculoIsSelected || estrutGerenIsSelected || estrutSuperIsSelected;

    if (!vinculoOrEstrutIsSelected) {
      const message = 'Selecione uma estrutura gerencial ou vínculo!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ALERT);
    }

    return vinculoOrEstrutIsSelected;
  }

  private previsaoFeriasOnSelection() {
    this.loadEstruturasSuperioresTipoHierarquiaInfo();
  }

  private previsaoFeriasBeforeGeneration(): boolean {
    return this.informeRendimentosBeforeGeneration();
  }

  private diasTrabalhadosOnSelection() {
    this.loadTiposVinculo();
  }

  private carregaTiposVinculo(){
    this.loadTiposVinculo();
  }

  private carregaLoteVinculo(){
    this.loadLoteVinculo();
  }

  private diasTrabalhadosBeforeGeneration() {
    return this.informeRendimentosBeforeGeneration();
  }

  private async loadTiposVinculo() {
    this.fieldsData.tiposVinculo = await AdmissaoController.getTipoVinculo();
  }

  private async loadVinculosEmpregaticios() {
    this.fieldsData.vinculosEmpregaticios = await AdmissaoController.getVinculoEmpregaticio();
  }

  private async loadLoteVinculo() {
    this.fieldsData.loteVinculos = await AdmissaoController.getLoteVinculos();
  }

  private async loadTiposDemissao() {
    this.fieldsData.tiposDemissao = await NovaSolicitacaoController.getTpDemissao();
  }
  
  private async loadMotivosRescisao() {
    this.fieldsData.motivosRescisao = await NovaSolicitacaoController.getMotivoResc();
  }

  private async loadTiposAviso() {
    this.fieldsData.tiposAviso = await NovaSolicitacaoController.getTpAvisoPrevio();
  }

  private async loadBeneficios() {
    this.fieldsData.beneficios = await NovaSolicitacaoController.getBeneficios();
  }

  private async loadTipoBeneficios() {
    this.fieldsData.tiposBeneficio = await SolicitacaoController.getTipoBeneficio();
  }

  private async loadTiposRelacionamento() {
    this.fieldsData.tiposRelacionamento = await NovaSolicitacaoController.getTipoRelacionamento();
  }

  private async loadTransferencias() {
    this.fieldsData.transferencias = await NovaSolicitacaoController.getMovimentacaoTransferencia();
  }

  private async loadMotivosTransferencia() {
    this.fieldsData.motivosTransferencia = await NovaSolicitacaoController.getMotivoTransferencia();
  }

  private async loadTipoAlteraSal() {
    this.fieldsData.tiposAlteraSal = await NovaSolicitacaoController.getTipoAlteraSal(false);
  }
  
  private async loadCursos() {
    this.fieldsData.cursos = await TreinamentoController.getCurso();
  }
  
  private async loadPerfisAcesso() {
    this.fieldsData.perfisAcesso = await TreinamentoController.getPerfilAcesso();
  }
  
  private async loadMetodos() {
    this.fieldsData.metodos = await TreinamentoController.getMetodo();
  }
  
  private async loadBeneficiosVC() {
    this.fieldsData.beneficiosCombustivel = await SolicitacaoController.getBeneficiosVCombust();
    if (this.fieldsData.beneficiosCombustivel && this.fieldsData.beneficiosCombustivel.length === 0) {
      SnackbarUtils.showMessage('Nenhum benefício de vale combustível foi identificado.', SnackbarUtils.TYPE_ALERT);
    }
  }

  private async loadBeneficiosVMautencao() {
    this.fieldsData.beneficiosManutencao = await SolicitacaoController.getBeneficiosVManutencao();
    if (this.fieldsData.beneficiosManutencao && this.fieldsData.beneficiosManutencao.length === 0) {
      SnackbarUtils.showMessage('Nenhum benefício de Vale Manutenção foi identificado.', SnackbarUtils.TYPE_ALERT);
    }
  }
  
  private async loadLinhas() {
    this.fieldsData.linhas = await NovaSolicitacaoController.getLinhaTransporteAtiva();
  }
  
  private async loadTiposLinha() {
    this.fieldsData.tiposLinha = await NovaSolicitacaoController.getTipolinhavinc();
  }
  
  private dtCompetenciaOnInput() {
    const currentReport = this.formRow.reportName;

    const reportsNotReloadVinculos = [
    ];

    if (!reportsNotReloadVinculos.includes(currentReport)) {
      if (this.user.dp) {
        this.getVinculosByEstruturaField();
      }
    }
  }

  private reciboPagamentoOnSelection() {
    this.loadBancos();
    this.loadEventos();
    this.loadEstruturasSuperioresTipoHierarquiaInfo();
  }

  public loadEstruturasSuperioresTipoHierarquiaInfo() {
    this.loadEstruturasSuperioresOperador();
    //this.loadTiposHierarquia();
    if (this.user.dp) {
      this.loadEstuturasSuperiores();
    }
  }

  private loadEstruturas() {
    this.loadEstruturasSuperioresTipoHierarquiaInfo();
    this.loadEstruturasGerenciais();
  }

  private async loadTiposHierarquia() {
    this.fieldsData.tiposHierarquia = await RelatorioController.getTiposHierarquia();
  }

  private async loadEstuturasSuperiores() {
    const nrTipoEstruturaSup: string = this.formRow.NRTIPOESTRUTSUP;

    if (Util.isUndefinedOrNull(nrTipoEstruturaSup)) {
      this.fieldsData.estruturasSuperiores = [];
      this.formRow.NRESTRUTSUPERIOR = null;
    } else {
      const nrTipo = parseInt(nrTipoEstruturaSup, 10);

      // this.fieldsData.estruturasSuperiores = await NovaSolicitacaoController.getEstrutura(
      //   nrTipo,
      // );
    }
  }

  private async loadEstruturasSuperioresOperador() {
    const estruturasSup = this.fieldsData.estruturasSuperioresOperador;

    if((estruturasSup && estruturasSup.length) || !this.estruturasGerenciaisStore) {
      return;
    }

    const estruturas = this.estruturasGerenciaisStore.filter((e) => e.NRESTRUTURAM !== '-1');
    this.fieldsData.estruturasSuperioresOperador = estruturas;
  }

  private async loadBancos() {
    try {
      this.fieldsData.bancos = await AdmissaoController.getBanco();
    } catch (err) {
      const message = 'Não foi possível carregar os bancos!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  private async loadEventos() {
    this.fieldsData.eventos = await OcorrenciaController.getEventosAtivos();
  }

  private tipoHierarquiaOnInput() {
    this.loadEstuturasSuperiores();
  }

  private estrutSuperiorOnInput() {
    this.getTipoHierarquiaByTipoEstrutura();
    this.changeEstruturaGerencialObrigatorioSolicitacao();
  }

  private changeEstruturaGerencialObrigatorioSolicitacao () {
    if(this.isReportSolicitacao) {
      this.estruturaGerencialObrigatorio = !this.formRow.NRESTRUTSUPERIOR;
    }
  }
  
  private async getTipoHierarquiaByTipoEstrutura() {
    try {
      const nrEstruturaSuperior = this.formRow && this.formRow.NRESTRUTSUPERIOR;
      const estrutura = this.fieldsData.estruturasSuperioresOperador.find((e) => e.NRESTRUTURAM == nrEstruturaSuperior);
  
      const nrTipoEstrutura = estrutura && estrutura.NRTIPOESTRUTURA;
  
      if(!Util.isEmptyOrBlank(nrTipoEstrutura)) {
        const tipoHierarquia: any = await RelatorioController.getTipoHierarquiaByTipoEstrutura(nrTipoEstrutura);
        
        this.formRow.NRTIPOHIERARQ = tipoHierarquia.TIPOHIERARQUIA.NRTIPOHIERARQORG;
      } else {
        this.formRow.NRTIPOHIERARQ = null;
      }
    } catch (error) {
      this.formRow.NRTIPOHIERARQ = null;
    }
  }

  private reciboPagamentoBeforeGeneration() {
    return this.informeRendimentosBeforeGeneration();
  }

  private setContentHeight() {
    const height = window.innerHeight - 90;
    this.contentHeight = height;
  }

  private pontoDemonstrativoVinculoOnInput(nrVinculo: string) {
    const vinculo = this.getVinculo(nrVinculo);

    if (vinculo) {
      this.formRow.NRTIPOVINCULOM = vinculo.NRTIPOVINCULOM;
      return;
    }

    this.formRow.NRTIPOVINCULOM = null;
  }

  private getVinculo(nrVinculo: string) {
    const vinculo = this.fieldsData.vinculos.find((item) => {
      return item.NRVINCULOM === nrVinculo;
    });

    return vinculo;
  }

  private async loadCanViewReports(): Promise<void> {
    this.canViewReports = await RelatorioController.getGestorCanViewReport();
  }

  public async loadTiposIncidencia(): Promise<void> {
    this.fieldsData.tiposIncidencia = await RelatorioController.getTiposIncidencia();
  }

  private async sendToSign(): Promise<void> {
    if (!this.reportLink) {
      const message = 'Favor gerar o relatório antes de proceder com seu envio para assinatura.';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ALERT);

      return;
    }

    const nrVinculo: string = this.formRow.NRVINCULOM;

    if (!nrVinculo) {
      const message = 'Favor selecionar um vínculo antes de proceder com seu envio para assinatura.';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ALERT);

      return;
    }

    const reportValue = this.formRow.reportName;
    const report = this.getReport(reportValue);
    const dsReport = report.name;

    const nmVinculo: string = this.formRow.NMVINCULOM;
    const nmVinculoUnderscore = Util.replaceAll(nmVinculo, ' ', '_');

    const dtCompetencia : string = this.formRow.DTMESCOMPETENCIA;
    const dtCompetenciaUndescore = Util.replaceAll(dtCompetencia, '/', '_');

    const nmDocumento = `${dsReport} - ${dtCompetencia} - ${nmVinculo}`;
    const nmFile = `${reportValue}-${dtCompetenciaUndescore}-${nmVinculoUnderscore}.pdf`;

    const reportDataUrl = FileUtils.getCompleteBase64(this.base64, this.type);

    const row = {
      NRVINCULOM: nrVinculo,
      NMDOCUMENTO: nmDocumento,
      FILE: reportDataUrl,
      NMFILE: nmFile,
    };

    this.assinaturaPopup.show = true;
    this.assinaturaPopup.row = row;
  }

  private ausenciaMarcacoesOnSelection() {
    this.formRow.DATA = DateUtil.getCurrentDate();
    this.loadEstruturasSuperioresTipoHierarquiaInfo();
  }

  private avisoFeriasOnSelection() {
    this.formRow.DATA = DateUtil.getCurrentDate();
    this.carregaLoteVinculo();
    this.loadEstruturasSuperioresTipoHierarquiaInfo();
  }

  private fixField() {
    if(!Util.isEmptyOrBlank(this.formRow.VRSALARIO)) {
      this.formRow.VRSALARIO = parseFloat(this.formRow.VRSALARIO).toFixed(2);
    }

    if(!Util.isEmptyOrBlank(this.formRow.VREVENTOFIXO)) {
      this.formRow.VREVENTOFIXO = parseFloat(this.formRow.VREVENTOFIXO).toFixed(2);
    }
    
    if(!Util.isEmptyOrBlank(this.formRow.VRREEMBOLSO)) {
      this.formRow.VRREEMBOLSO = parseFloat(this.formRow.VRREEMBOLSO).toFixed(2);
    }

    if(!Util.isEmptyOrBlank(this.formRow.VRTARIFA)) {
      this.formRow.VRTARIFA = parseFloat(this.formRow.VRTARIFA).toFixed(2);
    }
  }

  private getColumnsSoli(
    reportName: string
  ) {
    let columns = [
      'N. Solicitação',
      'Solicitação',
      'N. Vínculo',
      'Vínculo',
      'Estrutura Legal',
      'Estrutura Gerencial',
      'Data de abertura',
      'Status',
      'Observação',
      'Fase de Solicitação',
      'Fase seguinte'
    ];

    switch (reportName){
      case 'solicitacao_horas_extras':
        columns.push('Data da Realização das Horas Extras');
        columns.push('Hora Inicio');
        columns.push('Hora Fim');
        break; 
      case 'solicitacao_alteracao_escala':
        columns.push('Início da Escala');
        columns.push('Escala');
        columns.push('Turno');
        break; 
      case 'solicitacao_alteracao_salarial':
        columns.push('Nr. Ocorrência');
        columns.push('Dt de Alteração Salarial');
        columns.push('Tipo de Modalidade do Salário');
        columns.push('Valor Salário');
        columns.push('Tipo de Salário');
        columns.push('Tipo de Alteração Salarial');
        break; 
      case 'solicitacao_alteracao_ocupacao':
        columns.push('Dt. Início Sit. Funcional');
        columns.push('Tipo de Modalidade do Salário');
        columns.push('Nr. Ocupação');
        columns.push('Nr. Motivo Ocupação');
        columns.push('Nr. Tipo Ocupação');
        columns.push('Justificativa');
        break; 
      case 'solicitacao_aumento_quadro':
        columns.push('N° de Vagas');
        columns.push('Publicar Vaga');
        columns.push('Solicitante');
        columns.push('Responsável');
        columns.push('Nome do Processo');
        columns.push('Template');
        columns.push('Tipo do Processo');
        columns.push('Motivo');
        columns.push('Localidade');
        columns.push('Descrição');
        columns.push('Disponível desde');
        columns.push('Disponível até');
        columns.push('Data Prevista de Admissão');
        columns.push('Nr. Ocupação');
        columns.push('Escala');
        columns.push('Valor Salário');
        columns.push('Vínculo Empregatício');
        columns.push('Grau de Instrução');
        columns.push('CPF');
        columns.push('Nome');
        break; 
      case 'solicitacao_desligamento':
        columns.push('Reposição de Vaga');
        columns.push('Pessoa não Grata');
        columns.push('Possui bens da Empresa (Celular, Notebook e etc)');
        columns.push('Tipo de Demissão');
        columns.push('Tipo de Aviso Prévio');
        columns.push('Motivo da Rescisão');
        columns.push('Dt. da Solicitação de Desligamento');
        columns.push('Dt. do Último Dia Efetivamente Trabalhado');
        columns.push('Dt. Rescisão Projetada');
        break;
      case 'solicitacao_advertencia':
        columns.push('Situação Funcional');
        columns.push('Data Início');
        columns.push('Data Fim');
        columns.push('Qtde de Dias');
        break;
      case 'solicitacao_auxilio_moradia':
        columns.push('Tipo de Evento');
        columns.push('Tipo de Movimento');
        columns.push('Valor do Evento');
        columns.push('Início Vigência Conselho');
        columns.push('Fim Vigência Conselho');
        columns.push('Justificativa da Alteração');
        break;
      case 'solicitacao_beneficios':
        columns.push('Tipo de alteração');
        columns.push('Nr Pessoa');
        columns.push('Benefício');
        columns.push('Qtd. Benefício');
        columns.push('Justificativa da alteração');
        columns.push('Data Inscrição');
        columns.push('Data Cancelamento');
        break;
      case 'solicitacao_ferias':
        columns.push('Nr Período Férias');
        columns.push('Data Início Férias');
        columns.push('Qtd. de dias Férias');
        columns.push('Adiantamento de 13º');
        columns.push('Justificativa de férias');
        columns.push('Data Fim Férias');
        break;
      case 'solicitacao_inclusao_dependentes':
        columns.push('Tipo de relacionamento');
        columns.push('Nome');
        columns.push('Sexo');
        columns.push('CPF');
        break;
      case 'solicitacao_movimentacao_ocupacao_salario':
        columns.push('Nr. Ocorrência');
        columns.push('Tipo de Modalidade do Salário');
        columns.push('Estrutura Legal');
        columns.push('Estrutura Gerencial');
        columns.push('Transferência');
        columns.push('Motivo de Transferência');
        columns.push('Nr. Ocupação');
        columns.push('Nr. Motivo Ocupação');
        columns.push('Nr. Tipo Ocupação');
        columns.push('Valor Salário');
        columns.push('Tipo de Salário');
        columns.push('Tipo de Alteração Salarial');
        columns.push('Data Final');
        columns.push('Justificativa da Alteração');
        break;
      case 'solicitacao_reducao_salarial':
        columns.push('Dt de Alteração Salarial');
        columns.push('Nr. Ocorrência');
        columns.push('Tipo de Modalidade do Salário');
        columns.push('Início da Escala');
        columns.push('Data de Início');
        columns.push('Valor Salário');
        columns.push('Tipo de Salário');
        columns.push('Estrutura Legal (Item)');
        columns.push('Estrutura Gerencial (Item)');
        columns.push('Transferência');
        columns.push('Motivo de Transferência');
        columns.push('Nr. Ocupação');
        columns.push('Nr. Motivo Ocupação');
        columns.push('Nr. Tipo Ocupação');
        columns.push('Data Final');
        columns.push('Justificativa da Alteração');
        columns.push('Escala');
        columns.push('Turno');
        break;
      case 'solicitacao_reembolso':
        columns.push('Valor do Reembolso');
        columns.push('Competência');
        break;
      case 'solicitacao_transferencia_gerencial':
        columns.push('Tipo de Transferência');
        columns.push('Transferência');
        columns.push('Início da Escala');
        columns.push('Data de Início');
        columns.push('Tipo de Modalidade do Salário');
        columns.push('Estrutura (Item)');
        columns.push('Escala');
        columns.push('Turno');
        break;
      case 'solicitacao_transferencia_legal':
        columns.push('Tipo de Transferência');
        columns.push('Transferência');
        columns.push('Data de Início');
        columns.push('Tipo de Modalidade do Salário');
        columns.push('Início da Escala');
        columns.push('Estrutura Legal (Item)');
        columns.push('Estrutura Gerencial (Item)');
        columns.push('Escala');
        columns.push('Turno');
        break;
      case 'solicitacao_substituicao':
        columns.push('Nº de Vagas');
        columns.push('Publicar Vaga');
        columns.push('Solicitante');
        columns.push('Vínculo Substituído');
        columns.push('Tipo de Vínculo');
        columns.push('Vínculo Empregatício');
        columns.push('Nr. Ocupação');
        columns.push('Estrutura Gerencial (Item)');
        columns.push('Estrutura Legal (Item)');
        columns.push('Valor Salário');
        columns.push('Escala');
        columns.push('Nr. Grau de Instrução');
        columns.push('Data Prevista de Admissão');
        columns.push('Motivo da Admissão');
        columns.push('CPF');
        columns.push('Nome');
        break;
      case 'solicitacao_treinamento':
        columns.push('Treinamento Interno');
        columns.push('Nome');
        columns.push('Curso');
        columns.push('Perfil de Aprovação');
        columns.push('Método');
        columns.push('Perfil de Execução');
        columns.push('Início Planejado');
        columns.push('Fim Planejado');
        break;
      case 'solicitacao_vale_combustivel':
        columns.push('Tipo de alteração');
        columns.push('Tipo');
        columns.push('Qtd. Benefício');
        columns.push('Nr Pessoa');
        columns.push('Benefício');
        columns.push('Data Inscrição');
        columns.push('Data Cancelamento');
        columns.push('Justificativa da alteração');
        break;
      case 'solicitacao_vale_manutencao':
        columns.push('Tipo de alteração');
        columns.push('Nr Pessoa');
        columns.push('Benefício');
        columns.push('Qtd. Benefício');
        columns.push('Justificativa da alteração');
        columns.push('Data Inscrição');
        columns.push('Data Cancelamento');
        break;
      case 'solicitacao_vale_transporte':
        columns.push('Tipo de Alteração');
        columns.push('Data de Alteração');
        columns.push('Linha 1');
        columns.push('Valor da Tarifa 1');
        columns.push('Tipo da Linha 1');
        columns.push('Quantidade 1');
        columns.push('Linha 2');
        columns.push('Valor da Tarifa 2');
        columns.push('Tipo da Linha 2');
        columns.push('Quantidade 2');
        columns.push('Linha 3');
        columns.push('Valor da Tarifa 3');
        columns.push('Tipo da Linha 3');
        columns.push('Quantidade 3');
        columns.push('Linha 4');
        columns.push('Valor da Tarifa 4');
        columns.push('Tipo da Linha 4');
        columns.push('Quantidade 4');
        columns.push('Linha 5');
        columns.push('Valor da Tarifa 5');
        columns.push('Tipo da Linha 5');
        columns.push('Quantidade 5');
        columns.push('Linha 6');
        columns.push('Valor da Tarifa 6');
        columns.push('Tipo da Linha 6');
        columns.push('Quantidade 6');
        columns.push('Linha 7');
        columns.push('Valor da Tarifa 7');
        columns.push('Tipo da Linha 7');
        columns.push('Quantidade 7');
        columns.push('Linha 8');
        columns.push('Valor da Tarifa 8');
        columns.push('Tipo da Linha 8');
        columns.push('Quantidade 8');
        columns.push('Sentido da Linha');
        columns.push('Inicio de Validade');
        columns.push('Fim de Validade');
        columns.push('Justificativa da Alteração');
        break;
      default:
        break;
    }

    return columns;
  }

  private reduceData(data, columns) {
    let newData = [];
    let colRow = [];

    columns.forEach((col) => {
      colRow.push(col);
    });

    newData.push(colRow);

    data.forEach(dado => {
      let newEntries = [];
      const entries = Object.entries(dado);

      entries.forEach((e) => {
        newEntries.push(e[1]);
      });

      newData.push(newEntries);
    });

    return newData;
  }

  private get obrigarFiltroVinculoAssinatura() {
    return this.formRow.COMASSINATURADIGITAL == 'S';
  }

  // #endregion
}

export default Relatorio;
